RivalIQ.apps.SocialPosts.module('widgets', function (widgets, App, Backbone, Marionette, $, _, s, moment, LazyLoad) {

    'use strict';

    // This includes the two columns that are always present (publishedAt and post content).
    const MAX_EXPORT_COLUMNS = 5;
    const HD_MAX_EXPORT_COLUMNS = 6;
    const PORTRAIT_MAX_EXPORT_COLUMNS = 4;
    const MAX_POSTS_PER_ROW = 4;
    const MAX_MESSAGE_CHARS_TEXT_GRID_ITEM = 160;
    const MAX_MESSAGE_CHARS_TOP_POSTS_APP = 150;
    const MAX_MESSAGE_CHARS_TOP_POSTS_EXPORT = 120;
    const MAX_EXPORT_ROWS_WITHOUT_PAGE_BREAK = 3;

    const OTHER_PAGE_LOAD_DELAY_MS = 3000;
    const POST_TABLE_REFRESH_DELAY_MS = 2000;
    const IMAGE_LOADING_TOAST_DEBOUNCE_MS = 5000;
    const MAX_POSTS_IN_TABLE = 200; // This is based on config.elasticSearchQueryMaxDocumentsCount.
    const MAX_TOP_BOTTOM_POSTS_LIMIT = 9;
    const MIN_TOP_BOTTOM_POSTS_LIMIT = 3;
    const MIN_TOP_BOTTOM_POSTS = 6;

    const Dashboard = RivalIQ.apps.Dashboard;

    function shouldShowChannelPill(dashboardModel) {
        const channel = dashboardModel.getProp('channel');
        const source = dashboardModel.getProp('source');
        const showChannelPill = (source === RivalIQ.enums.sources.CROSS_CHANNEL || channel === 'cross_channel' || (_.isUndefined(source) && !channel));

        return showChannelPill;
    }

    function shouldShowPresenceHandle(dashboardModel) {
        const showPresenceHandle = dashboardModel.getProp('showPresenceHandle');
        return Boolean(showPresenceHandle);
    }

    function loadOtherPageImages(view) {
        setTimeout(function () {
            if (!view.isDestroyed) {
                view.$el.find('img.lazy-load').each((idx, el) => {
                    const $el = $(el);

                    const currentSrc = $el.attr('src');
                    const dataSrc = $el.attr('data-src');
                    const postId = $el.data('post-id');
                    if (postId && !currentSrc && dataSrc && RivalIQ.utils.BrokenThumbnailHandler.SupportedSources[postId.toString().split('.')[0]]) {
                        // force load the image
                        $el.attr('src', dataSrc);
                    }
                });
            }
        }, OTHER_PAGE_LOAD_DELAY_MS);
    }

    const debouncedShowToast = _.debounce(() => {
        RivalIQ.execute('alert:info', RivalIQ.strings.social_posts_loading_broken_images);
    }, {
        leading: true,
        trailing: false
    }, IMAGE_LOADING_TOAST_DEBOUNCE_MS);

    const showImageLoadingToast = _.memoize(function (dashboardModel) {
        if (!dashboardModel.isExporting() && !dashboardModel.getProp('isInPostTagEditMode') && !dashboardModel.getProp('suppressBrokenImageNotifications')) {
            debouncedShowToast();
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.SocialPostsBrokenImageToast, {
                accountUserId: RivalIQ.state.user.get('id'),
                landscapeId: dashboardModel.getProp('landscapeId'),
                timePeriod: dashboardModel.getProp('timePeriod')
            });
        }
    }, function (dashboardModel) {
        let timePeriodStr = '';
        const timePeriod = dashboardModel.getProp('timePeriod');
        if (timePeriod) {
            // startOf day since some time periods have second components.
            timePeriodStr = [
                moment.utc(timePeriod.mainPeriodStart).startOf('day').toISOString(),
                moment.utc(timePeriod.mainPeriodEnd).startOf('day').toISOString()
            ].join(';');
        }
        return timePeriodStr;
    });


    function isMp4VideoPost(post) {
        const mediaType = (post.get('media_type') || post.get('type') || '');
        return _.includes([RivalIQ.enums.sources.INSTAGRAM, RivalIQ.enums.sources.LINKEDIN], post.get('source')) && _.includes(['video', 'reel'], mediaType.toLowerCase());
    }

    function updateSelectAllCheckbox() {

        const me = this;

        if (!me.isRendered) {
            return;
        }

        const numPosts = _.size(me.dashboardModel.getLoadedPosts());
        const numSelectedPosts = _.size(me.dashboardModel.getSelectedPosts());

        if (numSelectedPosts === 0) {
            me.ui.selectAllInput.prop('checked', false);
            me.ui.selectAllInput.prop('indeterminate', false);
            me.dashboardModel.setQueryModeEnabled(false);
        } else if (numPosts === numSelectedPosts) {
            me.ui.selectAllInput.prop('checked', true);
            me.ui.selectAllInput.prop('indeterminate', false);
        } else {
            me.ui.selectAllInput.prop('checked', false);
            me.ui.selectAllInput.prop('indeterminate', true);
            me.dashboardModel.setQueryModeEnabled(false);
        }
    }

    function getPostTagCountsMetricDef(props) {
        const postTagIdsDef = new RivalIQ.models.MetricDefinition({
            concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS_POST_TAG_IDS.id,
            dimensions: ['post_tag_id'],
            property: 'count',
            limit: -1
        });
        App.utils.updateMetric(postTagIdsDef, props);

        return postTagIdsDef;
    }

    function getNumPostsCountsMetricDef(props) {
        const numPostsDef = new RivalIQ.models.MetricDefinition({
            concept: (props.domainsOnly ? RivalIQ.metrics.descriptions.SOCIAL_POSTS_POSTED_URLS.id : RivalIQ.metrics.descriptions.SOCIAL_POSTS.id),
            dimensions: [],
            property: 'count'
        });
        App.utils.updateMetric(numPostsDef, props);

        return numPostsDef;
    }

    function createLazyLoadInstance(gridView, onEnter) {
        return new LazyLoad({
            elements_selector: '.lazy-load',
            cancel_on_exit: false,
            callback_loaded: function (el) {
                if (el && onEnter) {
                    onEnter();
                }
            },
            callback_error: function (el) {

                const parent = $(el).parent();
                parent.css('background-image', '');
                parent.find('.no-video-thumbnail').removeClass('display-none');
                // don't hide videos we added because our cdn thumbnail failed
                if (!parent.hasClass('thumbnail-container')) {
                    parent.find('video').hide();
                }

                const childId = $(el).parent().data('post-id') || $(el).data('post-id');

                const imageSrc = el.src || $(el).data('bg');

                if ($(el).hasClass('cdn-thumbnail-img')) {
                    $('body').trigger('thumbnail.error', el);
                } else if (childId && imageSrc && gridView.collection) {
                    $('body').trigger('img.error', el);
                }
            }
        });
    }

    function getImageUrl(data) {
        return (data.imageLarge || data.image || data.platformImageUrl || _.get(data, ['display', 'html', 'imageUrl']));
    }

    const PostGridItem = RivalIQ.views.SocialPostGridItem = Marionette.LayoutView.mixin({

        behaviors: {
            Resizes: {
                handler: 'checkMetricNameForOverflow',
                behaviorClass: RivalIQ.graph.behaviors.Resizes
            }
        },

        className: function () {
            const me = this;

            const classes = ['social-post-grid-item', 'pointer'];
            if (App.utils.isGridDetailsLayout(me) || App.utils.isTopBottomDetailsLayout(me)) {
                classes.push('expanded');
            }

            if (App.utils.isGridSquareLayout(me) || App.utils.isTopBottomLayout(me)) {
                classes.push('fixed-dimensions');
            }

            const mediaType = (me.model.get('media_type') || me.model.get('type') || '').toLowerCase();
            classes.push(`post-type-${mediaType}`);

            const source = me.model.get('source');
            if (_.includes([RivalIQ.enums.sources.INSTAGRAM, RivalIQ.enums.sources.INSTAGRAM_INSIGHTS], source)) {
                classes.push('flex-thumbnail lazy-load');
            } else if (!isMp4VideoPost(me.model) && !me.dashboardModel.isExporting()) {
                classes.push('lazy-load');
            }

            const className = classes.join(' ');

            return className;
        },

        attributes: function () {
            const me = this;
            const attributes = {};

            if (App.utils.isGridBasedLayout(me)) {
                let url;

                const modelJson = me.model.toJSON();
                const isMp4 = isMp4VideoPost(me.model);

                const useCdnThumbnail = App.utils.shouldUseCdnThumbnail(modelJson.useThumbnailUrl, modelJson.image);

                if (isMp4) {
                    if (!me.dashboardModel.isExporting()) {
                        url = '/images/lazy-load-003.png';
                    }
                } else if (!modelJson.useThumbnailUrl) {
                    url = getImageUrl(modelJson);
                }

                if (url && !useCdnThumbnail) {
                    if (me.dashboardModel.isExporting() || isMp4) {
                        // NOTE we must mark this `!important` because of aggressive
                        // Bootstrap print styling that will hide it otherwise
                        attributes.style = `background-image: url("${url}") !important;`;
                    } else {
                        attributes['data-bg'] = url;
                        attributes.last_pull_attempt_at = modelJson.last_pull_attempt_at || modelJson.captured_at;
                    }
                }

                // Stick the model id on there so that the broken video handler can find the model if it needs to later.
                const id = me.model.get('id');
                attributes['data-post-id'] = id;
            }

            return attributes;
        },
        ui: {
            image: '.social-post-grid-item-image',
            postTagCheckbox: '.x-grid-item-select',
            popover: `[data-toggle='popover']`,
            tooltips: '[data-toggle="tooltip"]',
            details: '.details',
            metricName: '.social-post-grid-item-metric-name'
        },
        regions: {
            postTagPillsContainer: '.post-tag-pills'
        },
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        events: {
            click: 'onClick'
        },
        eventsNotToDebounce: {
            'change @ui.postTagCheckbox': 'onCheckboxToggled'
        },
        template: '#socialPostGridItemTemplate',
        templateHelpers: function () {
            const me = this;

            return _.defaults({
                formatAbbreviated: RivalIQ.formatter.formatAbbreviated,
                isExporting: me.dashboardModel.isExporting()
            }, RivalIQ.utils.emoji.getTemplateHelpers());
        },

        getMetricData: function () {
            const me = this;
            return me.model.attributes._parent;
        },

        getMetric: function () {
            const me = this;

            // right now, we are not dealing with stories or story days, that would need to be added as an option
            // this will probably need to use App.utils.createInsightsMetric (for private metrics) for stories support
            const concept = _.get(RivalIQ.enums.sourceDetails, [me.model.get('source'), 'privateData']) ?
                RivalIQ.metrics.descriptions.INSIGHTS_POSTS_SEARCH.id : RivalIQ.metrics.descriptions.SOCIAL_POST.id;

            const definition = _.extend({
                post: me.model.id,
                concept: concept
            }, App.utils.getOrderBy(me));

            return _.extend(new RivalIQ.models.MetricDefinition(definition), {
                data: me.getMetricData()
            });
        },

        serializeData: function () {
            const me = this;

            const model = me.model;
            const metric = me.getMetric();

            const data = model.toJSON();
            const metricType = metric.getMetricType();
            const imgSrc = data.useThumbnailUrl ? data.image : getImageUrl(data);
            const instagramVideoUrl = (isMp4VideoPost(model) ? App.utils.makePreviewVideoUrl(data.display?.video || data.display?.image || data.media_url) : null);

            const useCdnThumbnail = App.utils.shouldUseCdnThumbnail(data.useThumbnailUrl, data.image);

            let textOnlyMode;
            if (useCdnThumbnail) {
                textOnlyMode = false;
            } else if (isMp4VideoPost(model)) {
                textOnlyMode = !instagramVideoUrl || data.imageInvalid;
            } else {
                textOnlyMode = !imgSrc || data.imageInvalid || RivalIQ.utils.BrokenThumbnailHandler.isBrokenThumbnailUrl(imgSrc);
            }

            const showChannelPill = shouldShowChannelPill(me.dashboardModel);

            return _.defaults({
                imgSrc: imgSrc,
                isSquare: App.utils.isGridSquareLayout(me),
                isFocus: (data.company_id === RivalIQ.state.utils.getFocusedCompanyId()),
                isNonNumericMetric: (metricType === RivalIQ.enums.metricType.TEXT || metricType === RivalIQ.enums.metricType.STRING),
                metric: metric,
                disableLazyLoad: me.dashboardModel.isExporting(),
                noVideoPreviewAvailable: !useCdnThumbnail && (!imgSrc && model.get('type') === 'video'),
                textOnlyMode: textOnlyMode,
                maxMessageLength: MAX_MESSAGE_CHARS_TEXT_GRID_ITEM,
                metricName: metric.getName(),
                showChannelPill: showChannelPill,
                useCdnThumbnail: useCdnThumbnail,
                instagramVideo: instagramVideoUrl
            }, data, {
                presenceLink: '',
                last_pull_attempt_at: data.captured_at || null,
                platformImageUrl: data.media_url,
                message: data.caption,
                presence_link: `/company/${data.company_id}`,
                presence_name: data.company_name
            });
        },

        onAttach: function () {
            const me = this;

            // NOTE if the image fails to load then we must notify the grid
            // (which will remove the model from the collection entirely)
            me.ui.image.on('error', function (e) {

                if (!$(e.currentTarget).hasClass('cdn-thumbnail-img')) {
                    me.onImageLoadError(e.currentTarget.src);
                }
            });

            // NOTE some Facebook posts of type Link have funky images. we are
            // trying to detect them here, so that we can remove them from the
            // grid (see #14116)
            const channel = _.get(RivalIQ.enums.sourceDetails, [me.getProp('source'), 'privateData']) ? RivalIQ.data.channels.get(me.getProp('source')) : me.model.getChannel();
            if (channel.id === RivalIQ.enums.sources.FACEBOOK) {
                me.ui.image.on('load', function (e) {
                    const image = e.currentTarget;
                    const height = image.naturalHeight;
                    const width = image.naturalWidth;
                    // NOTE currently the only "funk" we detect is a natural
                    // image with 1x1 pixel dimensions
                    if (height === width && height === 1) {
                        me.onImageLoadError(image.src);
                    }
                });
            }
        },

        _updateLazyLoadVideo: function () {
            const me = this;

            const parent = me._parent;
            if (!me.dashboardModel.isExporting()) {
                if (!parent.lazyLoadInstance) {
                    parent.lazyLoadInstance = createLazyLoadInstance(parent);
                }

                parent.lazyLoadInstance.update();
            }
        },

        onAttachLoaded: function () {
            const me = this;

            me.checkMetricNameForOverflow();

            RivalIQ.apps.SocialPosts.utils.attachVideoOnLoadHandlers(me.$el);
            if (!me._parent.lazyLoadUpdate) {
                me._updateLazyLoadVideo();
            }

            // if we're a video, listen to video errors to fallback to text fallback mode.
            if (isMp4VideoPost(me.model)) {
                const video = me.$el.find('video')[0];
                if (video) {
                    video.addEventListener('error', function () {
                        $(video).removeClass('x-video-loading');
                        me.onImageLoadError(video.src);
                    });
                }
            }
        },

        onDestroy: function () {
            const me = this;

            if (me.lazyLoadInstance) {
                me.lazyLoadInstance.destroy();
            }
        },

        getMetricName: function () {
            const me = this;
            return me.getMetric().getName();
        },

        checkMetricNameForOverflow: function () {
            const me = this;

            // Using multiple lines is ok in export.
            if (!me.dashboardModel.isExporting()) {
                let metricName = me.getMetricName();

                if (metricName && me.ui.details && me.ui.details.removeClass) {
                    // The descriptions panel needs to be visible to measure the width of the metric name; we'll hide it again at the end of the measurement.
                    me.ui.details.removeClass('display-none');

                    const element = me.ui.metricName;
                    element.text(metricName);
                    element.css('overflow', 'scroll');
                    const isOverflowing = (Boolean(element[0]) && element[0].scrollWidth >= element[0].clientWidth);
                    if (isOverflowing) {
                        metricName = RivalIQ.utils.text.abbreviate(metricName);
                        element.text(metricName);
                    }
                    element.css('overflow', 'hidden');
                    me.ui.details.addClass('display-none');
                }
            }
        },

        onRender: function () {
            const me = this;
            me.ui.popover.popover({
                html: true
            });

            me.ui.tooltips.tooltip();

            if (me._parent.lazyLoadUpdate) {
                me._updateLazyLoadVideo();
            }

            // exclude showing post tags for discover (insta and twitter) post tables
            // NOTE: no grid view in twitter mentions or overview.
            if (!_.includes([RivalIQ.enums.widgetTypes.DISCOVERY_POST_TABLE, RivalIQ.enums.widgetTypes.OVERVIEW_CROSS_CHANNEL_TOP_POSTS], _.get(me, ['dashboardModel', 'widgetId']))) {
                me.postTagPills = new App.views.PostTagPills({
                    post: me.model,
                    postTagsById: _.get(me, ['options', 'postTagsById']) || {},
                    parentDashboardModel: me.dashboardModel,
                    postTagsClickable: false,
                    showActionBtns: !me.dashboardModel.isExporting()
                });

                me.postTagPillsContainer.show(me.postTagPills);
            }
        },

        onImageLoadError: function (imgSrc) {
            const me = this;

            RivalIQ.utils.BrokenThumbnailHandler.markThumbnailUrlBroken(imgSrc);

            if (me.isDestroyed) {
                return;
            }

            me.trigger('image:error', me.model);

            // switch to text only mode.
            me.model.set('imageInvalid', true);
            me.render();
        },

        onCheckboxToggled: function () {
            const me = this;

            const checked = me.ui.postTagCheckbox.prop('checked');
            me.$el.toggleClass('grid-item-selected', checked);

            const nativeId = me.model.get('native_id');
            const channel = RivalIQ.enums.sourceDetails[me.model.get('source')].channel;
            me.dashboardModel.setPostSelection(nativeId, channel, nativeId, checked);
        },

        onClick: function (e) {
            const me = this;

            const $target = $(e.target);

            // Links should not pop the modal
            if ($target.is('a') || me.getProp('noClickThrough')) {
                return;
            }

            if ($target.is('label') || $target.is('input')) {
                return;
            }

            const postTagsById = _.get(me, ['options', 'postTagsById']) || {};

            if ($target.hasClass('post-tag-action-btn') || $target.parents('.post-tag-action-btn').length) {
                e.stopPropagation();
                return;
            }

            if ($target.hasClass('grid-item-select-overlay') && !$target.hasClass('grid-item-interior-click-target')) {
                me.ui.postTagCheckbox.prop('checked', !me.ui.postTagCheckbox.prop('checked'));
                me.onCheckboxToggled();
                return;
            }

            if (_.get(RivalIQ.enums.sourceDetails, [me.model.get('source'), 'privateData'])) {
                RivalIQ.apps.Insights.widgets.media.utils.showDetails(me.dashboardModel, me.model.toJSON(), me.getOption('metric'), null);
                return;
            }

            const postTagIds = me.model.get('post_tag_ids') || [];
            const metric = me.getOption('metric');
            const channel = me.model.getChannel().get('channel');

            RivalIQ.execute('show:modal', {
                size: 'large',
                className: 'post-modal',
                tracking: {
                    options: {
                        channel: channel
                    },
                    metric: RivalIQ.tracking.metric.ViewedSocialPostsPostModal
                },
                information: {
                    title: 'Post Details',
                    content: RivalIQ.strings.social_post_details_info
                },
                contentView: new App.views.Post({
                    metric: metric.build({
                        channel: channel,
                        limit: 1,
                        post: me.model.id,
                        redactEngagementLift: me.getProp('redactEngagementLift')
                    }),
                    postTags: RivalIQ.postTags.utils.getPostTags(postTagIds, postTagsById),
                    showPostTags: me.getProp('showPostTags')
                })
            });
        }
    });

    const PostGrid = RivalIQ.views.SocialPostGrid = RivalIQ.views.CompositeView.mixin({

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            postTagManagerEventing: RivalIQ.postTags.mixins.PostTagsEventingMixin,
            brokenThumbnailHandler: RivalIQ.utils.BrokenThumbnailHandler
        },
        behaviors: {
            Resizes: {
                handler: 'onWindowResize',
                behaviorClass: RivalIQ.graph.behaviors.Resizes
            }
        },
        ui: {
            columns: '.x-social-post-grid-column',
            selectAllInput: 'input#select-all-posts'
        },
        eventsNotToDebounce: {
            'change @ui.selectAllInput': 'onSelectAllChange'
        },
        dashboardModelEvents: {
            'change': 'reload',
            'selectedPostsChanged': 'onSelectedPostsChanged',
            'selectedPostsReset': 'onSelectedPostsReset'
        },
        postTagManagerEvents: {
            'postTag:changed': 'onPostTagChanged',
            'postTag:deleted': 'onPostTagDeleted',
            'postTag:created': 'onPostTagCreated',
            'postTag:applied': 'onPostTagApplicationChange',
            'postTag:unapplied': 'onPostTagApplicationChange'
        },

        className: function () {
            const me = this;

            let classes = 'row social-post-grid';
            // NOTE: this class will hide the fourth post when the screen is small
            // only add to post widgets with a single row of posts
            if (me.getProp('limit') === MAX_POSTS_PER_ROW) {
                classes += ' social-post-grid-summary';
            }

            return classes;
        },

        // NOTE by providing an empty collection we can count on Marionette to
        // correctly listen to the object (e.g., `add`, `remove`, and `reset`
        // events will be covered); the same is not true if we monkeypatch the
        // property during `loadData`

        initialize: function () {
            const me = this;
            me.collection = new Backbone.Collection();
        },

        onDestroy: function () {
            const me = this;

            if (me.lazyLoadInstance) {
                me.lazyLoadInstance.destroy();
            }
        },

        childView: PostGridItem,
        childViewOptions: function () {
            const me = this;
            return {
                metric: me.metric,
                dashboardModel: me.dashboardModel,
                postTagsById: me.postTagsById
            };
        },
        childEvents: {
            'image:error': 'onImageError'
        },

        onPostTagChanged: function (postTag) {
            const me = this;
            me.$el.find(`.post-tag-${postTag.get('id')} .post-tag-pill-name`).html(RivalIQ.postTags.utils.postTagHtml(postTag.get('tag_name')));
        },

        onPostTagDeleted: function (postTag) {
            const me = this;
            me.$el.find(`.post-tag-${postTag.get('id')}`).hide();

            if (me.postTagsById) {
                delete me.postTagsById[postTag.id];
            }
        },

        onPostTagCreated: function (postTag) {
            const me = this;

            if (me.postTagsById) {
                me.postTagsById[postTag.id] = postTag.attributes;
            }
        },

        onPostTagApplicationChange: function (postTag, post) {
            const me = this;

            const gridItem = me.children.findByModel(post);

            if (gridItem) {

                const postStillMatches = App.mixins.PostTagsReload.postMatchesPostTagIdsFilter.call(me, post);

                if (postStillMatches) {
                    me.lazyLoadUpdate = true;
                    gridItem.postTagPills.render();
                } else {

                    gridItem.$el.velocity('fadeOut', {
                        duration: 250,
                        complete: function () {

                            me.removeChildView(gridItem);
                            me._relayoutChildren();
                            me.debouncedReloadPosts();
                        }
                    });
                }
            }
        },

        debouncedReloadPosts: function () {
            const me = this;

            if (!me._debouncedReloadPosts) {
                me._debouncedReloadPosts = _.debounce(function () {

                    const modelsBeforeLoad = _.clone(me.collection.models);
                    me.loadData()
                        .then(function () {
                            const models = me._filteredSortedModels();

                            me.$el.find('.social-post-grid-item.loading-grid-item').remove();
                            me.destroyEmptyView();
                            if (_.isEmpty(models)) {
                                me.showEmptyView();
                            } else {
                                const newChildren = [];
                                for (let index = 0; index < Math.max(modelsBeforeLoad.length, models.length); index++) {
                                    const existingModel = modelsBeforeLoad[index];
                                    if (existingModel) {
                                        const existingView = me.children.findByModel(existingModel);
                                        if (existingView) {
                                            me.removeChildView(existingView);
                                        }
                                    }

                                    const newModel = models[index];
                                    if (newModel) {
                                        const ChildView = me.getChildView(newModel);
                                        const newView = me.addChild(newModel, ChildView, index);
                                        newChildren.push(newView);
                                    }
                                }

                                _.each(newChildren, function (child, idx) {
                                    newChildren._index = idx;
                                });
                            }

                            // need to reattach the resize listener.
                            me.onAttachLoaded();
                        });
                }, POST_TABLE_REFRESH_DELAY_MS);
            }

            me.ensureGridLoadingItem();
            me._debouncedReloadPosts();
        },

        ensureGridLoadingItem: function () {
            const me = this;

            // don't show the loading item if we're not expecting to get new items.
            const limit = me.getProp('limit');
            if (limit && Number(limit) > me.collection.length) {
                return;
            }

            me.$el.find('.social-post-grid-item.loading-grid-item').remove();
            const destColumn = me.findNextGridItemColumn();

            const loadingGridItem = Marionette.TemplateCache.get('#socialPostGridItemLoadingTemplate')({
                isSquare: App.utils.isGridSquareLayout(me)
            });
            $(destColumn).append(loadingGridItem);
        },

        findNextGridItemColumn: function () {
            const me = this;

            const destColumn = _.reduce(me.ui.columns, function (memo, col) {
                if ($(col).children().length < $(memo).children().length) {
                    return col;
                }

                return memo;
            }, me.ui.columns[0]);

            return destColumn;
        },

        onSelectedPostsChanged: updateSelectAllCheckbox,
        onSelectedPostsReset: function () {
            const me = this;

            me.$el.find('.grid-item-select input').prop('checked', false);
            me.$el.find('.social-post-grid-item').toggleClass('grid-item-selected', false);
            me.onSelectedPostsChanged();
        },

        onSelectAllChange: function (e) {
            const me = this;

            const newState = $(e.target).prop('checked');
            const postsUpdate = me.collection.map(function (post) {
                return {
                    postId: _.head(post.get('id')),
                    channel: RivalIQ.enums.sourceDetails[post.get('source')].channel,
                    postNativeId: post.get('native_id')
                };
            });
            me.dashboardModel.setPostsSelection(postsUpdate, newState);

            // update all the checkboxes.
            me.$el.find('.grid-item-select input').prop('checked', newState);
            me.$el.find('.social-post-grid-item').toggleClass('grid-item-selected', newState);
        },

        onImageError: function () {
            const me = this;

            const resizeBehavior = _.find(me._behaviors, function (behavior) {
                return (behavior instanceof RivalIQ.graph.behaviors.Resizes);
            });

            resizeBehavior.resizeHandler(true);
        },
        emptyView: RivalIQ.views.ItemView.extend({
            template: '#overviewTopPostsEmptyPostsTemplate'
        }),
        emptyViewOptions: function () {
            const me = this;

            let message;
            const companyId = me.getProp('companyId');
            const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');

            if (companyId) {
                const companyName = RivalIQ.state.landscape.getCompanyById(companyId).get('name');
                message = `${companyName} did not publish any posts this period.`;
            } else {
                message = `There were no matching ${postWord}s in your landscape.`;
            }

            return {
                model: new Backbone.Model({
                    message: message,
                    hideTryAgain: false
                })
            };
        },
        template: '#socialPostGridTemplate',
        attachHtml: function (collectionView, childView, index) {
            const me = this;

            // NOTE `index` will be less than zero when we've filtered out all
            // of the models we had, and Marionette is expecting us to attach
            // an empty view.
            if (me.isEmpty() || index < 0) {
                // NOTE we must `empty` out our element so that the empty view
                // renders as expected (i.e., we want to remove the contents of
                // the template, which as of today is a few columns)
                me.$el.empty();
                return RivalIQ.views.CompositeView.prototype.attachHtml.apply(me, arguments);
            }

            const columnIndex = index % me.getColumns();
            // NOTE we cannot efficiently render when exporting, because we
            // will be loading images outside of the detection window causing
            // export to fail via timeout
            if (collectionView.isBuffering && !me.dashboardModel.isExporting()) {
                const buffer = collectionView._bufferedChildren[columnIndex] =
                    (collectionView._bufferedChildren[columnIndex] || []);
                buffer.push(childView);
            } else {
                const column = collectionView.ui.columns[columnIndex];
                column.appendChild(childView.el);
            }
        },
        _createBuffer: function () {
            const me = this;
            return _.map(me._bufferedChildren, function (column) {
                const fragment = document.createDocumentFragment();
                _.each(column, function (child) {
                    fragment.appendChild(child.el);
                });
                return fragment;
            });
        },
        attachBuffer: function (collectionView, buffer) {
            _.each(buffer, function (fragment, i) {
                collectionView.ui.columns[i].appendChild(fragment);
            });
        },
        serializeData: function () {
            const me = this;
            const exportColumnSize = me.getExportColumnSize();
            const widthClasses = me.dashboardModel.region === 'post-tags-manager' ? ['col-lg-4', 'col-md-6', 'col-sm-6'] : ['col-lg-3', 'col-md-4', 'col-sm-4', 'col-xs-12'];
            const exportClasses = ['col-sm-export', exportColumnSize].join('-');
            return {
                columns: 4,
                widthClasses: widthClasses.concat(exportClasses).join(' ')
            };
        },
        getBaseMetric: function () {
            const me = this;

            return _.defaults({
                concept: RivalIQ.metrics.descriptions.SOCIAL_POST.id,
                dimensions: ['post'],
                // NOTE we need to specify `concept` here so that the server
                // will construct the appropriate model; otherwise some sorts
                // would not work (see #14146)
                orderBy: _.defaults({
                    concept: RivalIQ.metrics.descriptions.SOCIAL_POST.id
                }, App.utils.getOrderBy(me)),
                property: 'post'
            }, me.getProps());
        },
        loadData: function () {
            const me = this;

            const config = me.getBaseMetric();
            const definition = new RivalIQ.models.MetricDefinition(config);
            const fetches = [RivalIQ.postTags.data.PostTags.fetch()];
            // NOTE: we pull posts and observations together, ignore second fetch
            const withObservations = me.getProp('withObservations');
            if (_.isUndefined(withObservations) || !withObservations) {
                fetches.push(definition.fetch());
            }

            if (me.getProp('isInPostTagEditMode')) {
                fetches.push(getPostTagCountsMetricDef(me.getProps()).fetch());
                fetches.push(getNumPostsCountsMetricDef(me.getProps()).fetch());
                fetches.push(RivalIQ.data.companyData.fetchPresences());
            }

            return $.when.apply($, fetches)
                .then(function (postTags, metric, postTagCounts, numPosts, companyData) {

                    me.postTagsById = _.keyBy(postTags, 'id');

                    if (me.getProp('withObservations')) {
                        me.metric = me.getProp('metric');
                    } else {
                        me.metric = metric;
                    }
                    let models = _.map(me.metric.getValue(), function (value) {
                        return _.last(value);
                    });

                    // NOTE we could get a cache hit of a request that
                    // specified a larger limit, so we need to make sure that
                    // if that happens we only consider up to our `limit`
                    // See #17126
                    const limit = me.getProp('limit');
                    if (limit > 0 && limit < _.size(models)) {
                        models = _.take(models, limit);
                    }

                    me.collection.reset(models, {
                        silent: true
                    });

                    if (me.getProp('isInPostTagEditMode') && RivalIQ.postTags.utils.canShowPostTagManager()) {
                        me.dashboardModel.setTotalNumPosts(numPosts.getValue({
                            format: false
                        }));
                        me.dashboardModel.setPostTagCounts(postTagCounts.getValue({
                            format: false
                        }));
                        me.dashboardModel.setLoadedPosts(models);
                        me.dashboardModel.companyData = companyData;
                    }
                });
        },

        onRenderLoaded: function () {
            const me = this;

            if (!me.dashboardModel.isExporting() && me.requestRenderedFrame) {
                me.requestRenderedFrame(function () {
                    if (me.lazyLoadInstance) {
                        me.lazyLoadInstance.destroy();
                    }

                    me.lazyLoadInstance = createLazyLoadInstance(me);
                    me.lazyLoadInstance.update();
                });
            }
        },

        onAttachLoaded: function () {
            const me = this;

            me.children.invoke('onAttachLoaded');
            loadOtherPageImages(me);
        },

        getExportColumnSize: function () {
            const exportColumnSize = 3;
            return exportColumnSize;
        },

        getColumns: function () {
            const me = this;

            let columns = 1;
            if (me.dashboardModel.isExporting()) {
                columns = 12 / me.getExportColumnSize();
            } else {
                const width = $(window).width();
                if (me.dashboardModel.region === 'post-tags-manager') {
                    if (width >= 1200) {
                        columns = 3;
                    } else {
                        columns = 2;
                    }
                } else {
                    if (width >= 1200) {
                        columns = 4;
                    } else if (width >= 768) {
                        columns = 3;
                    }
                }
            }

            return columns;
        },

        _relayoutChildren: function () {
            const me = this;

            const columns = me.getColumns();

            // Don't rely on me.children.each, as that uses js object iteration, not ordered by _index.
            const orderedChildren = me.children.reduce(function (memo, child) {
                memo[child._index] = child;
                return memo;
            }, new Array(me.children.length));

            _.each(orderedChildren, function (childView, i) {
                const el = childView.$el.detach();
                const column = me.ui.columns[i % columns];
                el.appendTo(column);
            });

            me.$el.data('columns', columns);
        },

        onWindowResize: function (override) {
            const me = this;

            // NOTE if we let the window resize run rampant then when the grid
            // is empty the code below will nuke the view (which we don't want)
            if (me.isEmpty()) {
                return;
            }

            const columns = me.getColumns();
            if (override === true || columns !== me.$el.data('columns')) {
                me._relayoutChildren();
            }
        }
    });

    const TopBottomPostGridItem = PostGridItem.extend({
        // overwrite this since we always use abbreviated metric names
        checkMetricNameForOverflow: () => {},

        template: '#topBottomSocialPostGridItemTemplate',

        getPostTypeIconPath: function (type) {
            const basePath = '/images/postTypeIcons/icon-';
            // this switch is case sensitive and private data returns "Carousel" or "Reel"
            switch (type.toLowerCase()) {
                case 'carousel':
                case 'video':
                case 'reel':
                case 'link':
                case 'image':
                    return `${basePath}${type.toLowerCase()}.svg`;
                case 'status':
                    return `${basePath}list.svg`;
                default:
                    return `${basePath}image.svg`;
            }
        },
        serializeData: function () {
            const me = this;
            const baseData = PostGridItem.prototype.serializeData.call(me);
            // always use abbrev metric names and special abbrev for eng rate by follower; see #31776 and #31665
            if (baseData.metricName === 'Engagement Rate by Follower' || baseData.metricName === 'Engagement Rate by Page Fan') {
                baseData.metricAbbrevName = 'Eng. Rate';
            } else {
                baseData.metricAbbrevName = RivalIQ.utils.text.abbreviate(baseData.metricName);
            }
            return _.extend(baseData, {
                postTypeIconPath: me.getPostTypeIconPath(baseData.type || baseData.media_type)
            });
        }
    });

    const TopBottomPostGrid = RivalIQ.views.SocialPostsTopBottomGrid = PostGrid.extend({
        loadData: function () {
            const me = this;
            const displayLimit = me.getProp('displayLimit');

            // NOTE: we already loaded data in TopBottomLayout for this post grid and passed as the postMetric prop
            // set up the collection with the already fetched metric and return an empty deferred.
            me.metric = me.getProp('postMetric');
            const postModels = _.take(_.map(me.metric.getValue(), function (value) {
                return _.last(value);
            }), displayLimit);
            me.collection.reset(postModels, {
                silent: true
            });
            const deferred = new Backbone.$.Deferred().resolve();
            return deferred;
        },
        getColumns: _.constant(3),
        serializeData: function () {
            const widthClasses = ['col-lg-4', 'col-md-4', 'col-xs-4'];
            return {
                columns: 3,
                widthClasses: widthClasses.join(' ')
            };
        },
        childView: TopBottomPostGridItem,
        childViewOptions: function () {
            const me = this;
            return {
                metric: me.metric,
                dashboardModel: me.dashboardModel,
                postTagsById: me.options.postTagsById
            };
        },
        emptyViewOptions: function () {
            return {
                model: new Backbone.Model({
                    message: 'No remaining matching posts in your landscape.',
                    hideTryAgain: false
                })
            };
        }
    });

    const TopBottomLayout = RivalIQ.views.TopBottomLayout = RivalIQ.views.LayoutView.mixin({
        className: 'row top-bottom-post-grids',
        template: '#topBottomPostsTemplate',
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        regions: {
            topPosts: '.x-top-posts',
            bottomPosts: '.x-bottom-posts',
            postsContainer: '.top-bottom-posts-container'
        },

        onRenderLoaded: function () {
            const me = this;

            if (me.totalPostCount < MIN_TOP_BOTTOM_POSTS) {
                me.showEmptyView();
            } else {
                me.showTopPostsWidget();
                me.showBottomPostsWidget();
            }
        },

        getGridLimit: function () {
            const me = this;
            if (me.dashboardModel.isExporting() && me.getProp('limit') <= MAX_TOP_BOTTOM_POSTS_LIMIT) {
                return me.getProp('limit');
            }
            if (!isSocialPostsCuration(me.dashboardModel.getCuration())) {
                return MAX_TOP_BOTTOM_POSTS_LIMIT;
            }
            return me.dashboardModel.isFocus() ? MAX_TOP_BOTTOM_POSTS_LIMIT : MIN_TOP_BOTTOM_POSTS_LIMIT;
        },

        getOrderBy: function () {
            const me = this;
            return App.utils.getOrderBy(me);
        },

        getBaseMetric: function (sortOrder) {
            const me = this;
            return _.defaults({
                concept: RivalIQ.metrics.descriptions.SOCIAL_POST.id,
                dimensions: ['post'],
                sortOrder: sortOrder,
                property: 'post',
                excludeNullPosts: true
            }, me.getProps());
        },

        onBeforeRenderLoaded: function () {
            const me = this;
            // set orderBy and limit on the dashboard so it extends to the PostGrid children & export props
            const orderBy = me.getOrderBy();
            const limit = me.getGridLimit();
            me.dashboardModel.setProps({
                orderBy,
                limit
            }, {
                silent: true
            });
        },

        loadData: function () {
            const me = this;

            const limit = me.getGridLimit();
            const topPostDefinition = new RivalIQ.models.MetricDefinition(me.getBaseMetric(1));
            const bottomPostDefinition = new RivalIQ.models.MetricDefinition(me.getBaseMetric(-1));
            const fetches = [
                topPostDefinition.fetch(),
                bottomPostDefinition.fetch(),
                RivalIQ.postTags.data.PostTags.fetch()
            ];

            return $.when.apply($, fetches)
                .then(function (topPostMetric, bottomPostMetric, postTags) {
                    // if we don't have enough posts to fill both grids show half or majority on top & half on bottom
                    // arbitrarily using the count of the topPostMetric. bottomPostMetric has the same count
                    const totalPostCount = topPostMetric.data.count;
                    if (totalPostCount < (limit * 2)) {
                        me.displayLimit = Math.floor(totalPostCount / 2);
                    } else {
                        me.displayLimit = limit;
                    }

                    me.totalPostCount = totalPostCount;
                    me.topPostMetric = topPostMetric;
                    me.bottomPostMetric = bottomPostMetric;

                    me.postTagsById = _.keyBy(postTags, 'id');
                });
        },

        getSocialPostWidget: function (topPosts) {
            const me = this;
            // clone the options & dashboardModel so the curation doesn't react to the different sortOrder settings
            const options = _.clone(me.options);
            const postMetric = topPosts ? me.topPostMetric : me.bottomPostMetric;
            options.postTagsById = me.postTagsById;
            options.dashboardModel.setProps({
                topBottomGrid: true,
                postMetric: postMetric,
                displayLimit: me.displayLimit,
                showPostTags: false
            }, {
                silent: true,
                navigate: me.navigate
            });
            return new TopBottomPostGrid(options);
        },

        showTopPostsWidget: function () {
            const me = this;
            const widgetView = me.getSocialPostWidget(true);
            me.topPosts.show(widgetView);
        },

        showBottomPostsWidget: function () {
            const me = this;
            const widget = me.getSocialPostWidget(false);
            me.bottomPosts.show(widget);
        },

        showEmptyView: function () {
            const me = this;
            const EmptyView = RivalIQ.views.ItemView.extend({
                template: '#overviewTopPostsEmptyPostsTemplate'
            });

            let message;
            const companyId = me.getProp('companyId');
            const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');

            if (companyId) {
                const companyName = RivalIQ.state.landscape.getCompanyById(companyId).get('name');
                if (!me.totalPostCount) {
                    message = `${companyName} did not publish any matching ${postWord}s this period.`;
                } else if (me.totalPostCount < MIN_TOP_BOTTOM_POSTS) {
                    message = `${companyName} published fewer than ${MIN_TOP_BOTTOM_POSTS} matching ${postWord}s. Please select another layout.`;
                }
            } else if (me.totalPostCount < MIN_TOP_BOTTOM_POSTS) {
                message = `There are fewer than ${MIN_TOP_BOTTOM_POSTS} matching ${postWord}s in your landscape. Please select another layout.`;
            }

            if (!message) {
                message = `There were no matching ${postWord}s in your landscape.`;
            }

            me.postsContainer.show(new EmptyView({
                model: new Backbone.Model({
                    message: message,
                    hideTryAgain: false
                })
            }));
        },

        serializeData: function () {
            const me = this;

            const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');
            return {
                postWord: postWord
            };
        }
    });

    PostGrid.types = {
        mosaic: 'grid',
        mosaicWithDetails: 'grid_with_details',
        grid: 'grid_square',
        gridWithDetails: 'grid_square_with_details'
    };

    TopBottomLayout.types = {
        topBottomsPosts: 'top_bottom_posts',
        topBottomsPostsWithDetails: 'top_bottom_posts_with_details'
    };

    const PresencePostCell = Marionette.LayoutView.extend({
        tagName: 'td',
        template: '#socialPostCellTemplate',
        className: 'post-overview',

        regions: {
            postTagPillsContainer: '.post-tag-pills'
        },

        templateHelpers: function () {
            const me = this;
            const post = me.getPost();
            const postPromotedLikelyhood = post.get('promoted_likelyhood');
            const hasLikelyPromoted = RivalIQ.state.account.get('plan').has_likely_promoted;

            return _.extend({
                s: s,
                isLikelyPromoted: (hasLikelyPromoted &&
                    postPromotedLikelyhood >= RivalIQ.enums.likelyPromoted.threshold),
                likelyPromotedDescription: RivalIQ.strings.likely_promoted_description,
                isExporting: me.options.table.dashboardModel.isExporting()
            }, RivalIQ.utils.emoji.getTemplateHelpers());
        },

        serializeData: function () {
            const me = this;
            const post = me.getPost();

            // adjust the maxMessageLength. for export, we want fewer chars to
            // make room for the link title, if there is one
            const showLink = App.utils.shouldShowLink(post);

            const maxMessageLength = (me.dashboardModel.isExporting() && showLink ?
                MAX_MESSAGE_CHARS_TOP_POSTS_EXPORT : MAX_MESSAGE_CHARS_TOP_POSTS_APP);

            const postJson = post.toJSON();
            postJson.canonicalUrl = postJson.canonicalUrl || null;

            const showChannelPill = shouldShowChannelPill(me.dashboardModel);
            const showPresenceHandle = shouldShowPresenceHandle(me.dashboardModel);

            const useCdnThumbnail = App.utils.shouldUseCdnThumbnail(postJson.useThumbnailUrl, postJson.image);

            return _.extend(postJson, {
                maxMessageLength: maxMessageLength,
                maxLinkTitleLength: 60,
                showLink: showLink,
                linkTitle: postJson.postedTitle || postJson.linkTitle,
                instagramVideo: (isMp4VideoPost(post) ? (RivalIQ.apps.SocialPosts.utils.makePreviewVideoUrl(postJson.display.video) || postJson.display.image) : null),
                disableLazyLoad: me.options.table.dashboardModel.isExporting(),
                presenceLink: null,
                last_pull_attempt_at: postJson.last_pull_attempt_at || postJson.captured_at,
                image: useCdnThumbnail ? postJson.image : getImageUrl(postJson),
                showChannelPill: showChannelPill,
                showPresenceHandle: showPresenceHandle,
                useCdnThumbnail: useCdnThumbnail
            }, me.getData(post));
        },

        getPost: function () {
            const me = this;
            const post = _.last(me.getOption('data'));
            return post;
        },

        getData: function () {
            const me = this;

            const post = me.getPost();
            let presenceLink;
            // TODO it would be nice if there was a better way...
            if (post.get('source') === RivalIQ.enums.sources.TWITTER) {
                const attributes = _.pick(me.model.attributes,
                    RivalIQ.apps.Mentions.curations.MentionsDetailsByMentioner.prototype.validCurationOptions);

                presenceLink = Dashboard.router.router.resolveCurationRoute(
                    RivalIQ.enums.curation.MENTIONS_MENTIONER_SUMMARY,
                    _.defaults({
                        presence_id: post.get('presence_id')
                    }, attributes));
            }

            return {
                isFocus: false,
                presence_link: presenceLink
            };
        }
    });

    const CompanyPostCell = PresencePostCell.extend({
        getData: function (post) {
            const company = post.getCompany();
            return {
                isFocus: (company.id === RivalIQ.state.utils.getFocusedCompanyId()),
                presence_link: `/company/${company.id}`
            };
        }
    });

    // We need to find the post metric; with mobile view and post tag edit modes,
    // it's not always at the same index, so use the metric collection to figure out where it is.
    function findPostMetric(collection) {
        return collection.find(function (m) { return m.get('property') === 'post'; });
    }

    Dashboard.mixins.PostTagsOnTable = {
        _renderTemplate: function () {
            const me = this;

            // remove all old post tag regions when we rerender the table
            if (me.rows) {
                me.removePostTagRegions();
            }

            RivalIQ.apps.Dashboard.widgets.MetricTable.prototype._renderTemplate.apply(me, arguments);
        },

        appendRowToBody: function (newRowHtml, startId, numRows) {
            const me = this;

            RivalIQ.apps.Dashboard.widgets.MetricTable.prototype.appendRowToBody.apply(me, arguments);

            // attach PostTagPills once row html has been appended so it will catch events
            // NOTE: forName prop is used for post tag modals (posts for tag 123)
            const objectType = me.getProp('objectType');
            if (me.dashboardModel.widgetId || me.getProp('forName') || me.getProp('modalWidget')) {
                if (Boolean(objectType) && objectType !== 'post') {
                    return;
                }
                me.addPostTagPillsComponentToRow(startId, numRows);
            }

            if (me.lazyLoadInstance) {
                me.lazyLoadInstance.update();
            }
        },

        removePostTagRegions: function () {
            const me = this;

            for (let i = 0; i < me.rows.length; i++) {
                if (me[`post-tag-${i}`]) {
                    me.removeRegion(`post-tag-${i}`);
                }
            }
        },

        addPostTagPillsComponentToRow: function (offset, numRows) {
            const me = this;

            const totalRowsToRender = offset + numRows;
            for (let rowId = offset; rowId < totalRowsToRender; rowId++) {
                const row = me.rows[rowId];
                // NOTE: me.rows is an array of arrays
                // The second entry is an array of first postId then the post model
                const post = _.get(row, [1, 1]);
                const postId = _.get(row, [1, 0]);
                if (post && postId) {
                    const pillRegionId = postId.replace('.', '_');

                    me.addRegion(`post-tag-${rowId}`, `#${pillRegionId}`);
                    const postModel = (post.attributes ? post : new Backbone.Model(post));
                    const _postTagPills = new RivalIQ.apps.SocialPosts.views.PostTagPills({
                        post: postModel,
                        postTagsById: me.postTagsById || {},
                        parentDashboardModel: me.dashboardModel,
                        postTagsClickable: false,
                        showActionBtns: (!me.getProp('modalWidget') || me.getProp('showPostTagActionsInModal')) && !me.dashboardModel.isExporting()
                    });
                    const postTagPillsComponent = me[`post-tag-${rowId}`];
                    if (postTagPillsComponent) {
                        postTagPillsComponent.postTagPills = _postTagPills;
                        postTagPillsComponent.show(_postTagPills);
                    }

                }
            }
        },

        debouncedReloadPosts: function () {
            const me = this;

            if (!me._debouncedReloadPosts) {
                me._debouncedReloadPosts = _.debounce(function () {

                    const rowsBeforeLoad = me.rows;
                    me.loadData()
                        .then(function () {
                            me.hideLoadingRow();

                            me._generateRowData();
                            if (me.rows.length) {

                                const existingRenderedRows = _.keyBy(me.ui.tbody.children(), function (tr) {
                                    return $(tr).data('index');
                                });

                                // Run through all the rows we should have in the table; some will be in the right spot already,
                                // some will need to be moved from another position in the table, and some will need to be rendered
                                // and placed.
                                let previousRow;
                                for (let rowIdx = 0; rowIdx < Math.max(rowsBeforeLoad.length, me.rows.length); rowIdx++) {

                                    const oldRow = rowsBeforeLoad[rowIdx];
                                    const newRow = me.rows[rowIdx];

                                    const oldRowPostId = _.get(oldRow, [0, 0]);
                                    const newRowPostId = _.get(newRow, [0, 0]);

                                    if (oldRowPostId === newRowPostId) {
                                        // The correct row is already in the right place, no work to do.
                                        previousRow = $(existingRenderedRows[rowIdx]);
                                        delete existingRenderedRows[rowIdx];
                                    } else if (newRowPostId) {

                                        const previouslyRenderedRowIdx = _.findIndex(rowsBeforeLoad, function (rowMetrics) {
                                            return _.get(rowMetrics, [0, 0]) === newRowPostId;
                                        });

                                        let renderedRow;
                                        if (previouslyRenderedRowIdx >= 0) {
                                            // if we have an already rendered row for this post, move it over
                                            renderedRow = $(existingRenderedRows[previouslyRenderedRowIdx]);

                                            // jquery.data() doesn't update the attribute; this is not strictly necessary, but it's
                                            // confusing when debugging if these two things don't lineup.
                                            renderedRow.attr('data-index', rowIdx);
                                            renderedRow.data('index', rowIdx);

                                            delete existingRenderedRows[previouslyRenderedRowIdx];
                                            renderedRow.detach();
                                        } else {

                                            // need to render a new row.
                                            const renderedRowHtml = me.renderMetricRow(newRow, rowIdx);
                                            me.appendRowToBody(renderedRowHtml, rowIdx, 1);
                                        }

                                        // move/insert the row to the right spot.
                                        if (renderedRow) {
                                            if (rowIdx === 0) {
                                                renderedRow.prependTo(me.ui.tbody);
                                            } else {
                                                renderedRow.insertAfter(previousRow);
                                            }
                                        }

                                        previousRow = renderedRow;
                                    }
                                }

                                // delete any old left over rows.
                                _.each(existingRenderedRows, function (leftoverTr) {
                                    $(leftoverTr).detach();
                                });

                            } else {
                                const EmptyView = me.getOption('emptyView');
                                const view = new EmptyView();
                                const html = view.render().el;

                                me.attachElContent(html);
                            }
                        });
                }, POST_TABLE_REFRESH_DELAY_MS);
            }

            // don't show the loading item if we're not expecting to get new items.
            const limit = me.getProp('limit');
            if (!limit || Number(limit) === -1 || Number(limit) <= me.rows.length) {
                me.showLoadingRow();
            }

            me._debouncedReloadPosts();
        },

        onPostTagApplicationChange: function (postTag, post) {
            const me = this;

            // update the post data row on the posts table
            const postRow = _.find(me.rows, function (row) {
                return row && row[1][1].id === post.id;
            });

            if (!postRow) {
                return;
            }

            postRow[1][1].post_tag_ids = post.get('post_tag_ids');

            // NOTE: id here is an int. in me.rows it's stored as a string.
            const postId = post.id;
            const postRowIdx = _.findIndex(me.rows, function (row) {
                return _.get(row, [0, 0]) === String(postId);
            });

            const postStillMatches = RivalIQ.apps.SocialPosts.mixins.PostTagsReload.postMatchesPostTagIdsFilter.call(me, post);
            if (!postStillMatches) {
                const postTr = me.$el.find(`tr[data-index=${postRowIdx}]`);
                // Need to null this out instead of deleting as we need to maintain the relationship between this
                // array and the list of trs in the table
                me.rows[postRowIdx] = null;
                postTr.velocity('fadeOut', {
                    duration: 250,
                    complete: function () {
                        me.debouncedReloadPosts();
                    }
                });
            } else {
                // Note: in custom dashboards, there can be multiple tables on the page. `me` might not have an entry for `post-tag-${postRowIdx}`,
                // so we can't just assume that `me['post-tag-' + postRowIdx].postTagPills` is defined.
                _.result(me[`post-tag-${postRowIdx}`], ['postTagPills', 'render']);
            }
        },

        // This is a little optmization to just update tag names on change (a more proper way to do it
        // would be to re-render, but I don't want to make the user wait 2-3 seconds).
        onPostTagChanged: function (postTag) {
            const me = this;
            me.$el.find(`.post-tag-${postTag.get('id')} .post-tag-pill-name`).html(RivalIQ.postTags.utils.postTagHtml(postTag.get('tag_name')));
        },

        onPostTagDeleted: function (postTag) {
            const me = this;
            me.$el.find(`.post-tag-${postTag.get('id')}`).hide();

            if (me.postTagsById) {
                delete me.postTagsById[postTag.id];
            }
        },

        onPostTagCreated: function (postTag) {
            const me = this;

            if (me.postTagsById) {
                me.postTagsById[postTag.id] = postTag.attributes;
            }
        }
    };

    const PostTable = Dashboard.widgets.MetricTable.mixin({

        ui: _.extend({
            'selectAllInput': '#post-tag-apply-SELECTALL'
        }, Dashboard.widgets.MetricTable.prototype.ui),

        eventsNotToDebounce: _.extend({
            'click @ui.selectAllInput': 'onSelectAllPostTagsClick',
            'change .post-tag-checkbox input': 'onPostTagSelectChange',

            // when the checkbox is visible, clicking the published at col will check the box.
            'click td.post-tag-checkbox-cell:visible+td': 'onPostTagPublishedAtClick'
        }, Dashboard.widgets.MetricTable.prototype.eventsNotToDebounce),

        dashboardModelEvents: _.extend({
            'selectedPostsChanged': 'onSelectedPostsChanged',
            'selectedPostsReset': 'onSelectedPostsReset',
            'queryModeEnabledChanged': 'onQueryModeEnabledChanged'
        }, Dashboard.widgets.MetricTable.prototype.dashboardModelEvents),

        mixins: {
            postTagsOnTable: Dashboard.mixins.PostTagsOnTable,
            postTagsReload: App.mixins.PostTagsReload,
            companySetChangeReload: RivalIQ.apps.Shell.mixins.CompanySetChangeReload
        },

        behaviors: function () {
            const me = this;

            const behaviors = _.clone(_.result(Dashboard.widgets.MetricTable.prototype, ['behaviors'])) || {};

            if (me.getProp('isInPostTagEditMode')) {
                behaviors.AffixedTableHeader = {
                    target: 'body > #application'
                };
            }

            return behaviors;
        },

        // NOTE: these functions are included in mixins.PostTagsOnTable
        postTagManagerEvents: {
            'postTag:changed': 'onPostTagChanged',
            'postTag:deleted': 'onPostTagDeleted',
            'postTag:applied': 'onPostTagApplicationChange',
            'postTag:unapplied': 'onPostTagApplicationChange',
            'postTag:created': 'onPostTagCreated'
        },

        onSelectedPostsChanged: updateSelectAllCheckbox,

        onSelectedPostsReset: function () {
            const me = this;
            me.$el.find('.post-tag-checkbox input').prop('checked', false);
            me.$el.find('tr').removeClass('row-selected');
            me.onSelectedPostsChanged();
        },

        onQueryModeEnabledChanged: function () {
            const me = this;
            me._toggleAllPostsForSelection(me.dashboardModel.getQueryModeEnabled());
        },

        rowClassName: function () {
            const me = this;
            return (me.getProp('noClickThrough') ? 'no-click-through' : 'pointer');
        },

        shouldShowHeaderSourceIcons: _.constant(false),

        _toggleAllPostsForSelection: function (newState) {
            const me = this;
            const postMetricIdx = me.collection.indexOf(findPostMetric(me.collection));
            const postsForSelection = _.map(me.rows, function (postRow) {
                const post = _.last(postRow[postMetricIdx]);
                return {
                    postId: _.head(postRow[postMetricIdx]),
                    channel: RivalIQ.enums.sourceDetails[post.get('source')].channel,
                    postNativeId: post.get('native_id')
                };
            });

            me.dashboardModel.setPostsSelection(postsForSelection, newState);

            // update all the checkboxes.
            me.$el.find('td .post-tag-checkbox input').prop('checked', newState);

            me.$el.find('tr').toggleClass('row-selected', newState);
        },

        onSelectAllPostTagsClick: function (e) {
            const me = this;

            const newState = $(e.target).prop('checked');
            me._toggleAllPostsForSelection(newState);
        },

        onPostTagPublishedAtClick: function (e) {
            const me = this;
            const rowIdx = $(e.target).parents('tr').data('index');
            if (_.isFinite(rowIdx)) {
                e.stopPropagation();

                const postRow = me.rows[rowIdx];
                const postId = postRow[0][0];

                const newState = !me.dashboardModel.isSelected(postId);
                me._togglePostSelected(postId, postRow, newState);
            }
        },

        _togglePostSelected: function (postId, postRow, selected) {
            const me = this;
            if (postRow) {
                const postMetricIdx = me.collection.indexOf(findPostMetric(me.collection));

                const newState = selected;
                const post = _.last(postRow[postMetricIdx]);
                me.dashboardModel.setPostSelection(postId, RivalIQ.enums.sourceDetails[post.get('source')].channel, post.get('native_id'), newState);

                const rowIdx = _.indexOf(me.rows, postRow);
                me.$el.find(`tr[data-index=${rowIdx}]`).toggleClass('row-selected', newState);
                me.$el.find(`tr[data-index=${rowIdx}] td.post-tag-checkbox-cell input`).prop('checked', newState);
            }
        },

        onPostTagSelectChange: function (e) {
            const me = this;

            const target = $(e.target);
            const postMetricIdx = me.collection.indexOf(findPostMetric(me.collection));
            const postId = target.data('post-id').toString();
            const postRow = _.find(me.rows, function (row) {
                return row[postMetricIdx][0] === postId;
            });

            me._togglePostSelected(postId, postRow, target.prop('checked'));
        },

        onRowClick: function (data, e) {
            const me = this;

            if (me._postTagAdderOpen) {
                return;
            }

            // Links and checkbox clicks should not pop the modal
            const target = $(e.target);
            if (target.is('a') || me.getProp('noClickThrough') || target.is('input') || target.is('label')) {
                return;
            }

            const metric = findPostMetric(me.collection);
            const postMetricIdx = me.collection.indexOf(findPostMetric(me.collection));
            const post = data[postMetricIdx][1];

            if (target.hasClass('post-tag-action-btn') || target.parents('.post-tag-action-btn').length) {
                e.stopPropagation();
                return;
            }

            const channel = RivalIQ.data.channels.get(post.get('source')).get('channel');

            const postTagIds = post.get('post_tag_ids') || [];
            const config = {
                metric: metric.build(_.defaults({
                    property: 'post',
                    post: post.id,
                    channel: channel,
                    limit: 1,
                    name: undefined
                }, me.getFetchAttributes())),
                postTags: RivalIQ.postTags.utils.getPostTags(postTagIds, me.postTagsById),
                showPostTags: me.getProp('showPostTags')
            };

            const categories = me.getProp('categories');
            if (categories) {
                config.categories = categories;
            }

            RivalIQ.execute('show:modal', {
                size: 'large',
                className: 'post-modal',
                tracking: {
                    options: {
                        channel: channel
                    },
                    metric: RivalIQ.tracking.metric.ViewedSocialPostsPostModal
                },
                information: {
                    title: 'Post Details',
                    content: RivalIQ.strings.social_post_details_info
                },
                contentView: new App.views.Post(config)
            });
        },

        onAttach: function () {
            const me = this;

            if (!me.lazyLoadInstance) {
                me.lazyLoadInstance = createLazyLoadInstance(me);
            }
        },

        onAllRowsRendered: function () {
            const me = this;

            RivalIQ.apps.Dashboard.widgets.MetricTable.prototype.onAllRowsRendered.apply(me, arguments);

            if (!me.lazyLoadInstance) {
                me.lazyLoadInstance = createLazyLoadInstance(me);
            }
            me.lazyLoadInstance.update();
            loadOtherPageImages(me);
        },

        _findPostData: function (postId) {
            const me = this;

            const postMetricIdx = me.collection.indexOf(findPostMetric(me.collection));
            const row = _.find(me.rows, function (row) {
                return row[0][0] === postId;
            });

            return _.get(row, [postMetricIdx, 1]);
        },

        loadData: function () {
            const me = this;

            const parentLoad = Dashboard.widgets.MetricTable.prototype.loadData.apply(me, arguments);

            const fetches = [
                RivalIQ.postTags.data.PostTags.fetch(),
                parentLoad
            ];

            if (me.getProp('isInPostTagEditMode')) {
                fetches.splice(1, 0, getPostTagCountsMetricDef(me.getProps()).fetch());
                fetches.splice(1, 0, getNumPostsCountsMetricDef(me.getProps()).fetch());
                fetches.splice(1, 0, RivalIQ.data.companyData.fetchPresences());
            }

            // this will trigger on the PostContainer
            me._parent.trigger('post:search:start');

            return $.when.apply($, fetches)
                .fail(function (e) {
                    // this will trigger on the PostContainer
                    me._parent.trigger('post:search:fail', e.errorName);
                })
                .done(function (postTags, companyData, numPosts, postTagCounts) {
                    // this will trigger on the PostContainer
                    me._parent.trigger('post:search:success');

                    if (me.collection) {
                        me.postTagsById = _.keyBy(postTags, 'id');

                        const postMetric = findPostMetric(me.collection);
                        const posts = _.map(postMetric.getValue(), _.last);
                        me.dashboardModel.setLoadedPosts(posts);

                        if (me.getProp('isInPostTagEditMode')) {
                            me.dashboardModel.setTotalNumPosts(numPosts.getValue({
                                format: false
                            }));
                            me.dashboardModel.setPostTagCounts(postTagCounts.getValue({
                                format: false
                            }));
                            me.dashboardModel.companyData = companyData;
                        }
                    }
                });
        },

        onRenderLoaded: function () {
            const me = this;

            // This is necessary for twitter mentions, which does not use the PostContainer
            // intermediary view.
            RivalIQ.postTags.utils.updateBodyClass(undefined, me.getProp('showPostTags'));
        },

        onAttachLoaded: function () {
            const me = this;

            Dashboard.widgets.MetricTable.prototype.onAttachLoaded.apply(me, arguments);

            RivalIQ.apps.SocialPosts.utils.attachVideoOnLoadHandlers(me.$el);
        },

        renderMetricRowCells: function (cells) {
            const me = this;

            const row = Dashboard.widgets.MetricTable.prototype.renderMetricRowCells.apply(me, arguments);

            if (me.getProp('noClickThrough')) {
                return row;
            }

            // add in the checkbox; we also make a td for the checkbox, and hide it with css.
            const postId = _.head(cells[0]);
            const checked = Boolean(_.find(me.dashboardModel.getSelectedPosts(), function (post) {
                return post.postId === postId;
            }));
            const checkboxHtml = $.tagHtml('td', {
                class: 'post-tag-checkbox-cell',
                html: Marionette.TemplateCache.get('#postTagCheckboxCellTemplate')({
                    postId: postId,
                    checked: checked
                })
            });

            return checkboxHtml + row;
        },

        renderTableHeaderRow: function () {
            const me = this;

            const headerRow = Dashboard.widgets.MetricTable.prototype.renderTableHeaderRow.apply(me, arguments);

            if (me.getProp('noClickThrough')) {
                return headerRow;
            }

            const checkboxHtml = $.tagHtml('th', {
                class: 'post-tag-checkbox-cell post-tag-selectall',
                html: Marionette.TemplateCache.get('#postTagCheckboxCellTemplate')({
                    postId: 'SELECTALL',
                    checked: false
                })
            });

            return checkboxHtml + headerRow;
        },

        renderTableHeaders: function (headerRowNode, columns) {
            const me = this;

            if (me.getProp('noClickThrough')) {
                return Dashboard.widgets.MetricTable.prototype.renderTableHeaders.apply(me, arguments);
            }

            _.each(headerRowNode?.children, function (node, i) {
                if (i === 0) {
                    return;
                }

                // need to account for the checkbox th, which does not have a corresponding column.
                Dashboard.widgets.table.HeaderCell.renderText(node, columns[i - 1]);
            });
        }
    });

    function removeStaticMetricColumns(metrics) {
        return _.reject(metrics, function (metric) {
            return _.includes(['post', 'published_at', 'post_tag_checkbox'], metric.property);
        });
    }

    function normalizeMetricColumns(widget, props) {
        const metrics = widget.metrics = props.metrics;

        const channel = widget.getProp('channel');
        const postWord = RivalIQ.data.channels.get(channel).get('postName');
        const postColumnName = (channel === RivalIQ.enums.channels.TIKTOK ? `Video post` : _.capitalize(postWord));
        const definitions = [
            {
                property: 'published_at',
                cellView: function () {
                    return RivalIQ.views.metric.PublishedAt;
                },
                header: {
                    className: 'post-published-timezone'
                }
            },
            {
                property: 'post',
                name: postColumnName,
                sortable: false,
                cellView: function () {
                    return widget.getPostCellView();
                },
                header: {
                    className: 'post-primary-column'
                }
            }
        ].concat(removeStaticMetricColumns(metrics));

        const built = _.map(definitions, function (config) {
            if (_.isString(config)) {
                config = {
                    property: config
                };
            }

            const definition = (new RivalIQ.models.MetricDefinition(config)).toJSON();
            return widget.metric.build(_.defaults(definition, _.pick(props, 'orderBy')));
        });

        // make sure the orderBy column is visible.
        const orderBy = _.get(props, 'orderBy');
        if (!_.isUndefined(orderBy) && props.columnLimit && orderBy >= props.columnLimit) {
            const orderByMetric = built[orderBy];
            props.orderBy = props.columnLimit - 1;
            if (orderByMetric) {
                built.splice(orderBy, 1);
                built.splice(props.orderBy, 0, orderByMetric);
            }
        }

        //let metrics = RivalIQ.metric.build(props, definitions);
        widget.metrics = RivalIQ.metric.pin(built, 1);
        widget.metricsCollection = new RivalIQ.collections.MetricDefinitions(widget.metrics);

        // NOTE we are overriding the post column serializer to expand into
        // several columns for CSV
        const postMetric = findPostMetric(widget.metricsCollection);
        const defaultSerializer = postMetric.serialize;
        postMetric.serialize = function (format) {
            const me = this;

            if (format === RivalIQ.enums.exportFormat.CSV) {
                return _.invokeMap([
                    widget.metric.build({
                        property: 'presence_handle'
                    }),
                    widget.metric.build({
                        property: 'postLink'
                    }),
                    widget.metric.build({
                        property: 'type'
                    }),
                    widget.metric.build({
                        property: 'message'
                    }),
                    widget.metric.build({
                        property: 'link'
                    }),
                    widget.metric.build({
                        property: 'linkTitle'
                    }),
                    widget.metric.build({
                        property: 'linkDescription'
                    }),
                    widget.metric.build({
                        property: 'image'
                    })
                ], 'serialize');
            }

            return defaultSerializer.apply(me, arguments);
        };
    }

    function getOrderBy() {

        const me = this;
        const metrics = me.metricsCollection;

        // If there are no custom columns sort by publishedAt
        if (metrics.length < 3) {
            return 0;
        }

        const orderBy = me.getProp('orderBy');
        if (_.isFinite(orderBy)) {
            return orderBy;
        } else if (_.isObject(orderBy)) {
            const orderIndex = _.findIndex(metrics.toArray(), function (metric) {
                const definition = metric.toType();
                return RivalIQ.metric.equal(definition, orderBy);
            });

            // NOTE it is possible that `metric` will not exist so we must be
            // ever vigilant...
            if (orderIndex === -1) {
                const firstCustomCol = metrics.findWhere(function (m) {
                    return m.get('sortable') && m.get('property') !== 'published_at';
                });
                return metrics.indexOf(firstCustomCol);
            }
            return orderIndex;
        } else {
            // sort on engagement rate first
            let sortCol = metrics.findWhere(function (m) {
                return m.get('property') === 'engagement_rate';
            });

            // if engagement rate is not available, pick first sortable column
            if (!sortCol) {
                sortCol = metrics.findWhere(function (m) {
                    return m.get('sortable') && m.get('property') !== 'published_at';
                });
            }
            return metrics.indexOf(sortCol);
        }
    }

    const ManageColumnsBtn = RivalIQ.views.Link.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        dashboardModelEvents: {
            'change:layout': 'onLayoutChange'
        },
        linkName: 'Manage Columns...',
        className: function () {
            const me = this;
            const className = ['btn', 'btn-default', 'btn-xs', 'manage-columns'];
            if (App.utils.isGridBasedLayout(me)) {
                className.push('hide');
            }
            return className.join(' ');
        },
        action: function () {
            const me = this;
            const metric = me.dashboardModel.metric;

            RivalIQ.execute('show:modal', new Dashboard.widgets.table.ColumnPicker({
                metric: metric.build({
                    limit: 1
                }),
                model: me.dashboardModel
            }));
        },
        onLayoutChange: function () {
            const me = this;
            me.$el.toggleClass('hide', App.utils.isGridBasedLayout(me));
        }
    });

    const ExportDropdown = widgets.ExportDropdown = Dashboard.views.ExportDropdown.extend({
        modelEvents: {
            'change:layout': 'render'
        }
    });

    const LayoutDropdown = widgets.LayoutDropdown = App.views.PostLayoutDropdown.extend({
        template: '#discoveryPostGridSwitchTemplate',
        onSelectDropdown: function (data) {
            const me = this;

            let layout = data.itemId;
            if (layout === 'list') {
                layout = undefined;
            }

            if (me.getOption('persistToSettings')) {
                // NOTE we want to use `data.itemId` so that we retain `list`
                // over `undefined` in settings
                App.utils.updateUserChannelLayout(me.getProp('channel'), data.itemId);
            }

            _.defer(function () {
                me.setProps('layout', layout);
            });

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ChangePostWidgetLayout, {
                channel: me.getProp('channel'),
                layout: data.itemId,
                curationId: me.dashboardModel.getCuration().id
            });

            if (_.includes(layout, RivalIQ.views.TopBottomLayout.types.topBottomsPosts)) {
                RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ViewedTopVsBottom, {
                    channel: me.getProp('channel'),
                    curationId: me.dashboardModel.getCuration().id
                });
            }
        }
    });

    const ShowPostTagsSwitch = RivalIQ.views.ShowPostTagsSwitch = RivalIQ.views.ItemView.mixin({
        attributes: {
            style: 'width: 100%'
        },

        template: '#socialPostsShowPostTagSwitchTemplate',

        className: 'show-post-tags-switch',

        ui: {
            showBtn: '.x-show',
            hideBtn: '.x-hide'
        },

        events: {
            'click @ui.showBtn': 'onShowClicked',
            'click @ui.hideBtn': 'onHideClicked'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        _updateShowPostTags: function (showPostTags) {
            const me = this;

            me.setProps('showPostTags', showPostTags, {
                silent: true
            });
            me.ui.showBtn.toggleClass('active', showPostTags);
            me.ui.hideBtn.toggleClass('active', !showPostTags);

            RivalIQ.postTags.utils.updateBodyClass(undefined, showPostTags);

            RivalIQ.settings.userSettings.showPostTags = showPostTags;

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ToggledShowPostTags, {
                showPostTags: showPostTags,
                layout: me.getProp('layout')
            });

            return RivalIQ.state.user.patchSettings({
                showPostTags: showPostTags
            });
        },

        onShowClicked: function () {
            const me = this;
            me._updateShowPostTags(true);
        },

        onHideClicked: function () {
            const me = this;
            me._updateShowPostTags(false);
        },

        serializeData: function () {
            const me = this;

            return {
                showPostTags: me.getProp('showPostTags')
            };
        }
    });

    function isSocialPostsCuration(curation) {
        return (curation.id === RivalIQ.enums.curation.SOCIALPOSTS);
    }

    function isPostTagsCuration(curation) {
        return (curation.id === RivalIQ.enums.curation.POSTTAGS);
    }

    function isPostTagsManagerCuration(curation) {
        return (curation.id === RivalIQ.enums.curation.POSTTAGSMANAGER);
    }

    function isCompanyProfileCuration(curation) {
        return (curation.id === RivalIQ.enums.curation.COMPANY_SOCIALPOSTS);
    }

    const PanelTitle = RivalIQ.views.ItemView.mixin({

        template: '#postsPanelTitleTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        tagName: 'h3',
        className: 'panel-title posts-panel-title',

        ui: {
            'title': '.panel-title-text',
            'selectAllLink': '.x-select-by-query',
            'info': '.fa-info-circle'
        },

        events: {
            'click @ui.selectAllLink': 'onSelectAllPostsClicked'
        },

        dashboardModelEvents: {
            'change': 'onDashboardModelChanged',

            // Normally would do a render for these, but the async load results in an unnecessary screen flash.
            'selectedPostsChanged': 'updateUi',
            'selectedPostsReset': 'updateUi',
            'loadedPostsChanged': 'updateUi'
        },

        loadData: function () {
            const me = this;

            const fetches = [];
            if (me.getProp('isInPostTagEditMode')) {
                fetches.push(getNumPostsCountsMetricDef(me.getProps()).fetch());
            }

            return $.when.apply($, fetches)
                .then(function (totalNumPosts) {
                    if (totalNumPosts) {
                        me.totalNumPosts = totalNumPosts.getValue({
                            format: false
                        });
                    } else {
                        me.totalNumPosts = null;
                    }
                });
        },

        onDashboardModelChanged: function (widget) {
            const me = this;

            if (me.getProp('isInPostTagEditMode')) {
                me.reload();
            } else if (_.has(widget.changed, 'title')) {
                // update the title if it's been override.
                me.render();
            }

            if (_.has(widget, ['changed', 'layout'])) {
                me.updateUi();
            }
        },

        templateHelpers: function () {
            return RivalIQ.utils.emoji.getTemplateHelpers();
        },

        serializeData: function () {
            const me = this;

            const data = {
                showSelectByQueryMessage: false,
                selectByQueryMessage: null
            };

            const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');
            const audienceName = me.getProp('channel') === 'facebook' ? 'Page Fan' : 'Follower';

            if (me.getProp('isInPostTagEditMode')) {
                const numSelectedPosts = _.size(me.dashboardModel.getSelectedPosts());

                let title;
                if (numSelectedPosts === 0) {
                    title = '0 posts selected';
                } else {
                    title = [
                        numSelectedPosts,
                        RivalIQ.formatter.numericLabel('post', 'posts', numSelectedPosts),
                        'selected'
                    ].join(' ');
                }

                const postsOnPage = me.dashboardModel.getLoadedPosts();
                const numPostsOnPage = _.size(postsOnPage);
                const showSelectByQueryMessage = (_.isFinite(me.totalNumPosts) &&
                    !_.isUndefined(postsOnPage) && me.totalNumPosts > numPostsOnPage &&
                    numSelectedPosts === numPostsOnPage);
                let selectByQueryMessage = null;
                if (showSelectByQueryMessage) {
                    if (me.dashboardModel.getQueryModeEnabled()) {
                        title = `All ${RivalIQ.formatter.formats.number(me.totalNumPosts)} matching posts in landscape selected.`;
                        selectByQueryMessage = 'Clear selection';
                    } else {
                        title = `All ${RivalIQ.formatter.formats.number(numPostsOnPage)} posts on this page are selected.`;
                        selectByQueryMessage = `Select all ${RivalIQ.formatter.formats.number(me.totalNumPosts)} matching posts in landscape.`;
                    }
                }

                data.title = title;
                data.showSelectByQueryMessage = showSelectByQueryMessage;
                data.selectByQueryMessage = selectByQueryMessage;
                data.description = RivalIQ.str('social_posts_top_landscape_posts_description', postWord);
            } else {
                data.title = me.dashboardModel.getTitle();
                data.description = RivalIQ.str('social_posts_top_landscape_posts_description', postWord);
            }

            if (App.utils.isTopBottomLayout(me)) {
                data.description = RivalIQ.str('social_posts_top_bottom_posts_description', postWord, audienceName);
            }

            return data;
        },

        onSelectAllPostsClicked: function (e) {
            const me = this;

            e.preventDefault();

            const queryModeEnabled = !me.dashboardModel.getQueryModeEnabled();
            me.dashboardModel.setQueryModeEnabled(queryModeEnabled);

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ToggledPostsSelectAll, {
                queryModeEnabled: queryModeEnabled
            });

            me.updateUi();
        },
        onRender: function () {
            const me = this;
            me.ui.info.popover({
                trigger: 'hover',
                container: 'body',
                placement: 'auto right',
                html: true
            });
        },
        updateUi: function () {
            const me = this;

            if (me.isRendered) {
                const data = me.serializeData();
                me.ui.title.text(data.title);

                // update tooltip text
                const popover = me.ui.info.data('bs.popover');
                if (popover) {
                    popover.options.title = data.title;
                    popover.options.content = data.description;
                }

                me.ui.selectAllLink.text(data.selectByQueryMessage);
                me.ui.selectAllLink.toggleClass('hidden', !data.showSelectByQueryMessage);
            }
        }
    });

    const PostPanel = widgets.PostPanel = Dashboard.views.Panel.extend({

        panelTitleView: PanelTitle,

        showActions: function () {
            const me = this;

            const dashboardModel = me.dashboardModel;
            const curation = dashboardModel.curation;

            if (isCompanyProfileCuration(curation) || isSocialPostsCuration(curation) || isPostTagsCuration(curation) || isPostTagsManagerCuration(curation)) {
                if (!App.utils.isTopBottomLayout(me)) {
                    me.actions.show(new ShowPostTagsSwitch({
                        dashboardModel: me.dashboardModel
                    }), {
                        preventDestroy: true
                    });
                }

                me.actions.show(new LayoutDropdown({
                    persistToSettings: isSocialPostsCuration(curation) || isPostTagsCuration(curation) || isPostTagsManagerCuration(curation),
                    dashboardModel: me.dashboardModel
                }), {
                    preventDestroy: true
                });

                if ((App.utils.isGridBasedLayout(me)) || (dashboardModel.isFocus() || isCompanyProfileCuration(curation) || isPostTagsCuration(curation) || isPostTagsManagerCuration(curation)) && App.utils.isGridBasedLayout(me)) {
                    me.actions.show(new App.views.SortDropdown({
                        template: '#socialPostsSortDropdownSmallTemplate',
                        dashboardModel: me.dashboardModel,
                        metric: new RivalIQ.models.MetricDefinition({
                            concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS.id
                        })
                    }), {
                        preventDestroy: true
                    });
                }
            }

            if (curation.isCustomDashboard) {
                me.showEditActions();
            } else if (me.getProp('manageableColumns') !== false && !App.utils.isGridBasedLayout(me)) {
                me.actions.show(new ManageColumnsBtn({
                    dashboardModel: me.dashboardModel
                }), {
                    preventDestroy: true
                });
            }

            if (!dashboardModel.isFocus() && !isCompanyProfileCuration(curation) && !dashboardModel.getProp('isInPostTagEditMode')) {
                me.showExportDropdown();
            }
        },

        onDashboardModelChange: function (props) {
            const me = this;
            Dashboard.views.Panel.prototype.onDashboardModelChange.apply(me, arguments);
            // NOTE only if we are not in custom dashboards do we want to mess
            // with the panel action toolbar
            if (!me.dashboardModel.curation.isCustomDashboard && _.get(me, ['actions', '$el'])) {
                me.requestRenderedFrame(function () {
                    me.actions.$el.empty();
                    me.actions.reset();
                    me.showActions();
                });
            }

            // handle if layout changed
            if (_.get(props, ['changed', 'layout'])) {
                me.onLayoutChange();
            }
        },

        onLayoutChange: function () {
            const me = this;
            me.showFooter();
        }
    });

    const PostContainer = RivalIQ.views.SocialPostContainer = RivalIQ.views.LayoutView.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            brokenThumbnailHandler: RivalIQ.utils.BrokenThumbnailHandler
        },
        regions: {
            container: '.post-container'
        },
        dashboardModelEvents: {
            'change:layout': 'reload'
        },
        getTemplate: _.memoize(function () {
            return _.template($.tagHtml('div', {
                class: 'post-container'
            }));
        }),
        onBeforeRenderLoaded: function () {
            const me = this;

            let View = PostTable;
            if (App.utils.isGridLayout(me)) {
                View = PostGrid;
            } else if (App.utils.isTopBottomLayout(me)) {
                View = TopBottomLayout;
            }

            RivalIQ.postTags.utils.updateBodyClass(undefined, me.getProp('showPostTags'));

            me.container.show(new View(me.options));
        }
    });

    const limitByLayout = {
        'list': 3,
        'top_bottom_posts': 3,
        'top_bottom_posts_with_details': 3
    };

    function getLimit(widget, layout, limit) {
        const curation = widget.curation;

        // NOTE when in summary view we need to adjust the limit based on
        // the active `layout` (also notice this behavior is ONLY for
        // Social Posts curations, rather than custom dashboards, or company
        // profiles)

        // NOTE: widget.isFocus can be misleading in custom dashboards since these widgets
        // are nested inside other widgets there; safer to look to see if an instanceId is set.
        const isFocused = Boolean(widget.getProp('instanceId'));
        if (_.result(curation, 'isExporting')) {
            return limit;
        } else if (isSocialPostsCuration(curation) && !isFocused) {
            limit = limitByLayout[layout] || 4;
        } else if (widget.getCuration().isCustomDashboard && !isFocused) {
            if (layout && layout !== 'list') {
                limit = 12;
            } else {
                limit = 10;
            }
        } else {
            if (_.includes(layout, TopBottomLayout.types.topBottomsPosts)) {
                limit = MAX_TOP_BOTTOM_POSTS_LIMIT;
            } else {
                limit = -1;
            }
        }

        return limit;
    }

    const PanelFooter = RivalIQ.apps.Dashboard.views.RowCountPanelFooter.mixin({
        template: '#postsPanelPanelFooterTemplate',

        ui: _.defaults({
            infoBubbles: '.fa-info-circle'
        }, RivalIQ.apps.Dashboard.views.RowCountPanelFooter.prototype.ui),

        mixins: {
            postTagsReload: App.mixins.PostTagsReload,
            companySetChangeReload: RivalIQ.apps.Shell.mixins.CompanySetChangeReload
        },

        shouldShowRowCountSummary: function () {
            const me = this;
            return !me.dashboardModel.hasViewMore();
        },

        loadData: function () {
            const me = this;

            const metric = me.dashboardModel.metric.build({
                property: 'count',
                dimensions: []
            }, {
                clobberDimensions: true
            });

            return metric.fetch().done(function (numPosts) {
                me.numPostsResults = numPosts;
                me.totalCount = numPosts.getValue();
                me.showingCount = Math.min(MAX_POSTS_IN_TABLE, numPosts.getValue({
                    format: false
                }));
            });
        },

        serializeData: function () {
            const me = this;

            let postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');
            const postWordPlural = `${postWord}s`;
            postWord = RivalIQ.formatter.numericLabel(postWord, postWordPlural, me.numPostsResults.getValue({
                format: false
            }));

            return {
                popoverText: `Rival IQ displays a max of ${MAX_POSTS_IN_TABLE} ${postWord}. To view other ${postWordPlural}, adjust your date range and filters.`,
                postWord: postWord
            };
        },

        onRenderLoaded: function () {
            const me = this;

            RivalIQ.apps.Dashboard.views.RowCountPanelFooter.prototype.onRenderLoaded.call(me);

            me.ui.infoBubbles.popover();
        }
    });

    const TopBottomPostsFooter = RivalIQ.views.SocialPostsTopBottomFooter = RivalIQ.apps.Dashboard.views.LoadingPanelFooter.extend({
        template: '#topBottomPostsPanelPanelFooterTemplate',
        // this footer is text only, no data to load, so overwrite loadData and beforeRenderLoaded
        loadData: undefined,
        beforeRenderLoaded: _.constant(),
        onRenderLoaded: function () {
            const me = this;
            me.$el.removeClass('display-none');
        },

        serializeData: function () {
            const me = this;

            const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');
            return {
                postWord: postWord
            };
        }
    });

    const PresencePostsWidget = RivalIQ.views.PresencePostsWidget = Dashboard.widgets.ChartWidget.mixin({

        mixins: {
            postSelection: RivalIQ.postTags.mixins.PostSelectionMixin
        },

        view: PostTable,
        panelView: PostPanel,
        footerView: function (curation) {
            if (App.utils.isTopBottomLayout(curation.dashboardModel)) {
                return new TopBottomPostsFooter(curation);
            }
            return new PanelFooter(curation);
        },
        detailPanelView: PostPanel,
        pdfView: App.views.PdfPanel,
        pngView: App.views.PngPanel,
        postCellView: PresencePostCell,
        getPostCellView: function () {
            const me = this;
            return me.postCellView.extend({
                dashboardModel: me
            });
        },
        getChartTitle: function () {
            const me = this;
            return me.getProp('title');
        },
        allowPageBreaks: function () {
            const me = this;
            const limit = me.getProp('limit');
            return (limit === -1) || (limit > MAX_EXPORT_ROWS_WITHOUT_PAGE_BREAK);
        },
        viewMorePath: Dashboard.widgets.TableWidget.prototype.viewMorePath,
        // NOTE this is primarily here for the single widget curation case
        // (e.g., Company Profile Social Posts)
        hasViewMore: function () {
            const me = this;
            const limit = me.getProp('limit');

            if (me.getCuration().isCustomDashboard) {
                return limit !== -1;
            } else {
                return limit !== -1 && limit <= MAX_POSTS_PER_ROW;
            }
        },
        hasFooter: _.constant(true), // we're always showing the view more or the count
        defaultProps: {},
        processProps: function (props, changed) {
            const me = this;

            let channel = props.channel;
            // cross-channel is undefined, so we don't want to override that if it's been explicitely set to undefined.
            if (!channel && !_.has(props, 'channel')) {
                channel = _.get(props, ['metrics', 0, 'channel']);
            }

            let layout;
            // NOTE for the time being we need to try to detect if we are in a
            // custom dashboard, or in Social Posts
            if (me.curation.getProps) {
                const curationProps = me.curation.getProps();
                if (_.has(curationProps, 'channel') && (isSocialPostsCuration(me.curation) || isPostTagsCuration(me.curation) || isPostTagsManagerCuration(me.curation))) {
                    layout = App.utils.getDefaultLayoutByChannel(props.channel, me.curation.id);
                }
            }

            let defaultShowPostTags = RivalIQ.settings.userSettings.showPostTags;
            if (_.isUndefined(defaultShowPostTags)) {
                defaultShowPostTags = true;
            }

            // hide post tags by default
            if (App.utils.isTopBottomLayout(me)) {
                props.showPostTags = false;
                if (props.orderBy?.property === 'presence_reach') {
                    props.orderBy = undefined;
                }
            }

            props = _.defaults(props, {
                channel: channel,
                sortOrder: 1,
                layout: layout,
                // NOTE if no `limit` exists we should default to three
                limit: 3,
                showDescriptions: true,
                visibleMobile: [1],
                showPostTags: defaultShowPostTags
            }, me.defaultProps);

            props.limit = getLimit(me, (layout || props.layout), props.limit);

            if (_.isString(props.orderBy)) {
                props.orderBy = props.orderBy.split(',');
            }

            // NOTE we cannot pass `orderBy` into the base, as it messes with
            // the cache layer
            me.metric = me.getBuildableMetric(_.omit(props, 'orderBy'));

            normalizeMetricColumns(me, props);
            // translate orderBy from object to number when switching to list view
            if (props.layout === 'list' && _.isObject(props.orderBy)) {
                // coming from another template, we need to update our orderBy
                props.orderBy = getOrderBy.call(me, props);
            } else {
                _.defaults(props, {
                    orderBy: getOrderBy.call(me, props)
                });
            }

            // we want to unselect all the posts unless the user was just changing metrics.
            if (!_.isEmpty(changed) && !(_.size(changed) === 1 && Boolean(changed.metrics))) {
                me.resetSelectedPosts();
            }

            RivalIQ.postTags.utils.updateBodyClass(undefined, me.getProp('showPostTags'));

            return props;
        },
        processExportProps: function (props, changed) {
            const me = this;

            // in the export case, we'll have post and published_at already in the set of metrics. Let's remove them
            // since we're going to add them back in normalizeMetricColumns.
            props.metrics = removeStaticMetricColumns(props.metrics);

            const orientation = me.getExportOrientation(props.format);
            if (me.isExportHD()) {
                props.columnLimit = HD_MAX_EXPORT_COLUMNS;
            } else if (orientation === RivalIQ.enums.orientation.PORTRAIT) {
                props.columnLimit = PORTRAIT_MAX_EXPORT_COLUMNS;
            } else {
                props.columnLimit = MAX_EXPORT_COLUMNS;
            }

            props.limit = Dashboard.widgets.TableWidget.prototype.getVisualExportLimit.call(me, props);

            return me.processProps(props, changed);
        },
        getExportMetricDefinitions: function (format) {
            const me = this;

            return _.map(me.metricsCollection.reject({
                property: 'post_tag_checkbox'
            }), function (metric) { return metric.serialize(format); });
        },

        exportFormats: App.utils.gridExportFormats,
        getExportDropdownView: _.constant(ExportDropdown),
        propsToSerializeForExport: App.utils.widgetExportProps.concat('metrics', 'title', 'layout'),
        csvExportProps: RivalIQ.apps.Dashboard.widgets.TableWidget.prototype.csvExportProps,
        getExportTitle: App.utils.exportTitle,
        getExportSubtitle: App.utils.exportSubtitle,
        getPptSubtitle: App.utils.pptSubtitle,
        getExportOrientation: function (format) {
            const me = this;
            const orientation = me.getProp('orientation');

            if (orientation) {
                return orientation;
            }

            if (format === RivalIQ.enums.exportFormat.PPT || App.utils.isTopBottomLayout(me)) {
                return RivalIQ.enums.orientation.LANDSCAPE;
            }

            return RivalIQ.enums.orientation.PORTRAIT;
        },
        // NOTE we have to override the base implementations of these two
        // methods so that the widget will properly export in HD from a details
        // view (where applicable, today only in the Custom Dashboards curation)
        getExportWidth: function () {
            const me = this;
            // #16812
            // if we're exporting the entire curation, defer to it's width,
            // if we're exporting just this widget, use HD so we get more columns
            if (!me.curation.isFocus() || App.utils.isTopBottomLayout(me)) {
                return RivalIQ.apps.Dashboard.mixins.ExportHD.getExportWidth();
            }
            return me.curation.getExportWidth();
        },
        getReportAttributes: function () {
            const me = this;
            const baseAttrs = RivalIQ.apps.Dashboard.mixins.Export.getReportAttributes.call(me);
            const attrs = _.extend({}, baseAttrs, {
                width: me.getExportWidth()
            });
            return attrs;
        },
        getUsePdfPostMargin: function () {
            const me = this;
            return me.curation.getUsePdfPostMargin();
        },
        filter: function () {
            const me = this;
            return !RivalIQ.props.channelAccess(me.getProps());
        },

        /**
         * Returns a base set of metric attributes from which to build.
         * @returns {Object}
         */
        getBuildableMetricAttributes: function (props) {
            const metric = _.head(_.get(props, 'metrics'));
            const attributes = _.clone(_.omit(metric, ['name', 'sortable']));
            return attributes;
        },

        /**
         * Returns a base metric definition from which to build.
         * @param {Object} props
         * @returns {RivalIQ.models.MetricDefinition}
         */
        getBuildableMetric: function (props) {
            const me = this;
            const attributes = me.getBuildableMetricAttributes(props);
            const metrics = RivalIQ.metric.build(props, [attributes]);
            const definition = _.head(metrics);
            const metric = new RivalIQ.models.MetricDefinition(definition);
            return metric;
        },
        isSupported: _.constant(true),

        propsToSerialize: ['metrics', 'channel', 'layout', 'limit'],
        propsToOmitFromSerialization: [],

        getPropsForSerialization: function (props) {
            const me = this;

            // NOTE the world we live in is complicated. we need to prevent the
            // `searchTerm` and `type` from being persisted outside of Custom Dashboards.
            // the problem is that when we reach this method in a details view,
            // the `props` contain those from the curation (like `searchTerm` and `type`),
            // which don't exist in other usages (like Custom Dashboards, or
            // like the summary view in Social Posts). see #12905
            let propsToOmit = [].concat(me.propsToOmitFromSerialization);
            if (isSocialPostsCuration(me.curation)) {
                propsToOmit.push('layout');
                propsToOmit.push('type');
                propsToOmit = propsToOmit.concat(_.keys(RivalIQ.enums.searchFieldNames));
            } else if (isCompanyProfileCuration(me.curation)) {
                propsToOmit.push('orderBy');
                propsToOmit.push('sortOrder');
            }

            const extensions = _.pick(me.getProps(), me.propsToSerialize);
            return _.mergeEnumerable(_.omit(_.defaults(props, extensions), propsToOmit));
        },

        getPropsForCurationExport: Dashboard.widgets.TableWidget.prototype.getPropsForCurationExport,

        propValues: {
            columnWidth: [12]
        },
        getSize: function () {
            const me = this;

            const curation = me.getCuration();
            if (!me.isFocus() && curation.id === RivalIQ.enums.curation.DASHBOARDS) {
                return RivalIQ.enums.widgetSize.FULL_PAGE;
            }
            return RivalIQ.enums.widgetSize.THIRD_PAGE;
        },
        getSlideDescriptions: _.constant([]),
        getValidChannels: function () {
            const publicChannelsWithSearch = RivalIQ.data.channels.withSearch().withAccess().notHidden(true);

            return RivalIQ.data.channels.filter(function (channel) {
                return Boolean(publicChannelsWithSearch.get(channel.id));
            });
        },

        getPostsQuery: function () {
            const me = this;

            let props = me.getProps();
            props = _.extend(me.getProps(), {
                startDate: moment.utc(props.timePeriod.mainPeriodStart).format('YYYY-MM-DD'),
                endDate: moment.utc(props.timePeriod.mainPeriodEnd).format('YYYY-MM-DD')
            });
            props = _.pick(props, _.without(App.utils.validQueryParams, 'orderBy', 'sortOrder'));

            if (!props.channel) {
                props.channel = 'cross_channel';
            }

            // if the user selected a company filter, we want to replace the filter with the list of companyIds. See #21806
            // TODO clean up use of tag here
            if (props.tag) {
                props.companyIds = me.companyData.getCompanyIdsByCompanySet(props.tag);
                delete props.tag;
            }

            return props;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.PRESENCE_SOCIAL_POSTS, PresencePostsWidget);

    const SocialPostsWidget = RivalIQ.apps.SocialPosts.widgets.SocialPostsWidget = PresencePostsWidget.mixin({
        // TODO it should be possible to promote this container to the parent
        // widget in the future, but at the moment it is incompatible with
        // mentions
        view: PostContainer,
        mixins: {
            // NOTE we can't use this on the parent widget because it enforces
            // presence ownership in the landscape, which is a condition that
            // is not strictly true in Mentions, for example, further, there
            // is little benefit there considering the current implementation
            // will only repull images for Facebook and Instagram (as of 2018-03-06)
            brokenThumbnailHandler: RivalIQ.utils.BrokenThumbnailHandler
        },

        initialize: function () {
            const me = this;

            me.listenTo(me, 'brokenpostimage', function () {
                showImageLoadingToast(me);
            });

            PresencePostsWidget.prototype.initialize.apply(me, arguments);
        },

        isFocus: function () {
            const me = this;
            return isCompanyProfileCuration(me.getCuration()) || Dashboard.widgets.ChartWidget.prototype.isFocus.call(me);
        },

        postCellView: CompanyPostCell,
        getChartTitle: function () {
            const me = this;

            const title = me.getProp('title');

            if (title) {
                return title;
            }

            const postWord = _.capitalize(RivalIQ.data.channels.get(me.getProp('channel')).get('postName'));
            if (App.utils.isTopBottomLayout(me)) {
                return RivalIQ.str('social_post_top_bottom_posts_title', _.capitalize(postWord));
            }

            const strName = me.getProp('companyIds') ? 'social_posts_posts_title_company' : 'social_posts_posts_title_landscape';

            return RivalIQ.str(strName, postWord);
        },
        getSlideElements: App.utils.getSlideElements,
        description: function () {
            const me = this;

            const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');
            const audienceName = me.getProp('channel') === 'facebook' ? 'Page Fan' : 'Follower';
            if (App.utils.isTopBottomLayout(me)) {
                return RivalIQ.str('social_posts_top_bottom_posts_description', postWord, audienceName);
            }

            if (me.curation.id === RivalIQ.enums.curation.DASHBOARDS) {
                const components = [];

                if (me.getProp('searchTerm')) {
                    components.push(`Filter: ${_.escape(me.getProp('searchTerm'))}`);
                }

                if (me.getProp('type')) {
                    components.push(`Post type: ${me.getProp('type')}`);
                }

                let addendum;
                if (!_.isEmpty(components)) {
                    addendum = ['<br/>'].concat(components).join('<br/>');
                }

                return RivalIQ.str('social_posts_widget_description', addendum || '');
            }

            const strName = (me.isFocus() ? 'social_posts_top_posts_info' : 'social_posts_mini_top_posts_info');
            return RivalIQ.str(strName, postWord);
        },
        csvExportProps: function (props) {
            const me = this;

            // TODO HACK
            // When we migrated scheduled topContent csv exports we didn't include widget options,
            // Since we're going to export all the columns anyway, fall back to sort by engagement_rate in this case
            let orderBy;
            if (props.metrics) {
                orderBy = me.metricsCollection.getOrderBy(props.orderBy);
            } else {
                orderBy = 'engagement_rate';
                props.metrics = ['engagement_rate'];
            }

            return {
                type: 'metric',
                metric: me.metric.build({
                    limit: -1,
                    sortOrder: props.sortOrder,
                    orderBy: orderBy,
                    includePostTagColumns: true
                }).serialize(),
                // don't include our postId as a column
                includeDimensionColumn: false
            };
        },
        getFilename: function () {
            const me = this;
            const companyId = me.getProp('focusCompanyId');
            const company = RivalIQ.state.landscape.getCompanyById(companyId);
            return RivalIQ.export.filename.base({
                title: me.getTitle(),
                companyName: company.get('name')
            });
        },
        getBuildableMetricAttributes: function () {
            return {
                concept: RivalIQ.metrics.descriptions.SOCIAL_POST.id,
                descriptionDimensions: ['channel', 'post'],
                dimensions: ['post']
            };
        },
        getBuildableMetric: function (props) {
            const me = this;
            const metric = PresencePostsWidget.prototype.getBuildableMetric.apply(me, arguments);
            App.utils.updateMetric(metric, props);
            return metric;
        },
        getPropsForCurationExport: function () {
            const me = this;
            return _.pick(me.getProps(), 'sortOrder', 'orderBy', 'showPostTags');
        },

        areAllMetricsValid: function (metrics) {
            const me = this;

            const props = me.getProps();
            const allMetrics = RivalIQ.apps.Favorites.data.metrics.getMetricSelectOptions(me, props.source, props, me.curation.baseMetric);

            return metrics.all(function (metric) {
                return Boolean(_.find(allMetrics, function (knownMetric) {
                    return knownMetric.metric.property === metric.get('metric').property;
                }));
            });
        },

        getBuilderFields: function () {
            const me = this;

            const metricsCollection = new RivalIQ.apps.Favorites.collections.Metrics(me.getProp('metrics'), {
                parse: true,
                baseMetric: me.curation.baseMetric,
                widget: me
            });

            const selectedSource = _.get(RivalIQ.data.channels.get(me.getProp('channel')), ['attributes', 'source'], RivalIQ.enums.sources.CROSS_CHANNEL);
            return [
                {
                    type: 'source_only',
                    onChange: function (source) {

                        const me = this;
                        const metric = me.dashboardModel.baseMetric;

                        const channel = RivalIQ.data.channels.get(source);
                        let channelName = channel.get('channel');
                        if (channel.isCrossChannel()) {
                            channelName = undefined;
                        }

                        const newProps = {
                            channel: channelName,
                            source: source
                        };

                        const postTypeFilter = me.dashboardModel.getProp('type');
                        if (postTypeFilter) {
                            const filterNotApplicable = !_.find(App.utils.getPostMediaTypeFilterItems(source), {
                                id: postTypeFilter
                            });
                            if (filterNotApplicable) {
                                newProps.type = undefined;
                            }
                        }

                        metric.channel = channelName;
                        me.dashboardModel.setProps(newProps, {
                            silent: true,
                            navigate: false
                        });
                        me.dashboardModel.setBaseMetric(metric);
                    },
                    size: 4,
                    selected: selectedSource
                },
                {
                    type: 'postFilter',
                    size: 8
                },
                {
                    type: 'postType',
                    items: function () {
                        return App.utils.getPostMediaTypeFilterItems(me.getProp('source'));
                    },
                    onBaseMetricChanged: function (view) {
                        view.reload();
                    },
                    size: 3
                },
                {
                    type: 'layout',
                    size: 3
                },
                {
                    type: 'postTagIds',
                    size: 3
                },
                {
                    type: 'postTagVisibility',
                    size: 3
                },
                {
                    type: 'metrics',
                    size: 12,
                    title: 'Metrics',
                    metrics: metricsCollection,
                    onBaseMetricChanged: function (view) {

                        let currentMetrics = me.getProp('metrics');
                        let metricsCollection = new RivalIQ.apps.Favorites.collections.Metrics(currentMetrics, {
                            parse: true,
                            baseMetric: me.curation.baseMetric,
                            widget: me
                        });

                        if (!me.areAllMetricsValid(metricsCollection)) {
                            currentMetrics = me.getProp('defaultMetrics');
                            me.curation.setProps({
                                metrics: currentMetrics
                            }, {
                                navigate: false
                            });

                            metricsCollection = new RivalIQ.apps.Favorites.collections.Metrics(currentMetrics, {
                                parse: true,
                                baseMetric: me.curation.baseMetric,
                                widget: me
                            });
                        }

                        // reset the metrics set to be appropriate for this source.
                        view.model.set({
                            metrics: metricsCollection
                        });
                        view.renderMetrics();
                    }
                }
            ];
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SOCIAL_POSTS, SocialPostsWidget);

}, window.s, window.moment, window.lazyload);
